import {
	ChangeDetectorRef,
	Component,
	Input,
	OnInit,
	ViewChild,
	ChangeDetectionStrategy,
	Inject,
	Optional,
} from "@angular/core";

import {
	IDataOptions,
	PivotFieldListComponent,
	PivotViewComponent,
	EnginePopulatedEventArgs,
	IDataSet,
	ToolbarService,
	FieldListService,
	NumberFormattingService,
	CalculatedFieldService,
	CalculatedFieldCreateEventArgs,
	GroupingBarService,
	FieldDropEventArgs,
	ISort,
	VirtualScrollService,
	IPivotValues,
	IPageSettings,
	DrillThroughEventArgs,
	DrillThroughService,
	PivotActionFailureEventArgs,
	QueryCellInfoEventArgs,
} from "@syncfusion/ej2-angular-pivotview";
import {
	L10n,
	enableRipple,
	Browser,
} from "@syncfusion/ej2-base";
import { GridSettings } from "@syncfusion/ej2-pivotview/src/pivotview/model/gridsettings";
import {
	sortBy,
	differenceWith,
	startsWith,
	cloneDeep,
	uniqBy,
	filter as _filter,
	maxBy,
	minBy,
	sumBy,
	meanBy,
} from "lodash";
import { DashboardService } from "../../dashboard.service";
import {
	AGGREGATE_TYPES_TEXT,
	ALL_AGGREGATE_TYPES,
	DashboardPorletsService,
} from "../../dashboardPorlets.service";
import { Observable, Subscription } from "rxjs";
import { MaskedTextBox } from "@syncfusion/ej2-inputs/src/maskedtextbox/maskedtextbox";
import { DataManager } from "@syncfusion/ej2-data/src/manager";
import { Predicate, Query } from "@syncfusion/ej2-data/src/query";
import { DataUtil } from "@syncfusion/ej2-data";
import moment from "moment";
import { PBF_TOKEN } from "../../../service/InjectionToken";
import { getTranslation } from "../../../utils/utils";

enableRipple(false);

@Component({
	selector: "rs-gadget-pivot",
	templateUrl: "./gadget-pivot.component.html",
	styleUrls: ["./gadget-pivot.component.scss"],
	providers: [
		ToolbarService,
		FieldListService,
		NumberFormattingService,
		CalculatedFieldService,
		GroupingBarService,
		VirtualScrollService,
		DrillThroughService,
	],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GadgetPivotComponent implements OnInit {
	@Input() portlet;
	@Input() dashboard;
	@Input() portlets;
	private Pivot_Data: IDataSet[];
	private config;
	public dataSourceSettings: IDataOptions;
	public gridSettings: GridSettings;
	private excludeFields = [];
	private filterSettings = [];
	private datePipeFormat;
	public translation;
	@ViewChild("pivotview", { static: false })
	private pivotObj: PivotViewComponent;
	@ViewChild("pivotfieldlist", { static: false })
	public fieldlistObj: PivotFieldListComponent;
	private observable = new Observable();
	private grandTotals = {};
	private subTotals = {};
	private flag: boolean = false;
	private previousSort: ISort;
	private subscriptions: Subscription[] = [];
	private allDataValue;
	// private calculatedFieldSettings;
	private isInit: boolean = true;
	private pivotSearchBox: MaskedTextBox;
	public tooltipSettings = {
		enable: false,
	};
	private columnTexts = [];
	private configFields = [];
	private quarterFormat = [
		{ value: "03/2021", format: "MM/yyyy" },
		{ value: "03/21", format: "MM/dd" },
		{ value: "3/2021", format: "M/yyyy" },
		{ value: "3/21", format: "M/yy" },
		{ value: "March 2021", format: "MMMM yyyy" },
		{ value: "Mar, 2021", format: "MMM, yyyy" },
		{ value: "March, 2021", format: "MMMM, yyyy" },
		{ value: "2021", format: "yyyy" },
	];
	zoomSettings = {
		enable: false,
	};
	itemDataTypeSortArr = [
		"Assets",
		"Liabilities",
		"Equity",
		"P&L",
		"Cashflow",
	];
	private formatDates = [];
	private customCalculatedFields: any[] = []; // 自定义计算列
	private allowedCalculatedFields: any[] = []; // 允许自定义算法的字段
	private zeroFormatData = {
		emptyList: [],
		hgList: [],
	};
	private millionFields = [];
	private tempSubtotals = [];
	public orderByColumns; // Eg: "DueDate, Sequence"
	public isApplyIRR: boolean = false;
	public calcIRRData: any;
	private percentNumFields = [];
	public pageLoading;

	constructor(
		private dashboardPorletsService: DashboardPorletsService,
		private dashboardService: DashboardService,
		private ref: ChangeDetectorRef,
		@Optional() @Inject(PBF_TOKEN) private pbf: any,

	) {}

	ngOnInit() {
		this.getInfo();
		L10n.load({
			"en-US": {
				pivotview: AGGREGATE_TYPES_TEXT,
				pivotfieldlist: AGGREGATE_TYPES_TEXT,
			},
			zh: {
				pivotview: AGGREGATE_TYPES_TEXT,
				pivotfieldlist: AGGREGATE_TYPES_TEXT,
			},
			"zh-Hant-HK": {
				pivotview: AGGREGATE_TYPES_TEXT,
				pivotfieldlist: AGGREGATE_TYPES_TEXT,
			},
			ja: {
				pivotview: AGGREGATE_TYPES_TEXT,
				pivotfieldlist: AGGREGATE_TYPES_TEXT,
			},
			ko: {
				pivotview: AGGREGATE_TYPES_TEXT,
				pivotfieldlist: AGGREGATE_TYPES_TEXT,
			},
			fr: {
				pivotview: AGGREGATE_TYPES_TEXT,
				pivotfieldlist: AGGREGATE_TYPES_TEXT,
			},
		});
		this.getData();
	}

	ngAfterViewInit(): void {
		this.subscriptions.push(
			this.dashboardService.getchangePivot().subscribe((updated) => {
				if (updated === this.portlet.newId) {
					this.getData();
				}
			})
		);

		this.subscriptions.push(
			this.dashboardService.getStartRefresh().subscribe((dashboardId) => {
				if (dashboardId === this.dashboard.id) {
					this.pageLoading = true;
					this.ref.markForCheck();
				}
			})
		);

		this.subscriptions.push(
			this.dashboardService.getUpdated().subscribe((newId) => {
				if (newId === this.portlet.newId || newId === this.portlet.id) {
					this.getData();
					if (this.pivotObj) this.pivotObj.refreshData();
				}
			})
		);

		this.subscriptions.push(
			this.dashboardService.getRefreshGadget().subscribe((e) => {
				if (!e) {
					return;
				}
				const id = e["newId"];
				if (id === this.portlet.newId || id === this.portlet.id) {
					this.pageLoading = false;
					this.getData();
				}
			})
		);

		this.subscriptions.push(
			this.dashboardService.getTableFormat().subscribe((updated) => {
				if (updated === this.portlet.newId) {
					this.getData();
					if (this.pivotObj) this.pivotObj.refreshData();
				}
			})
		);

		this.subscriptions.push(
			this.dashboardService
				.clearFieldListObservable()
				.subscribe((updated) => {
					if (updated === this.portlet.newId) {
						this.pivotObj.dataSourceSettings.dataSource = [];
						if (this.pivotObj) this.pivotObj.refreshData();
						if (this.fieldlistObj)
							this.fieldlistObj.updateDataSource();
						this.ref.markForCheck();
						this.ref.detectChanges();
					}
				})
		);

		// title change
		this.subscriptions.push(
			this.dashboardService.updatePortletTitle().subscribe((updated) => {
				if (updated) {
					this.config = JSON.parse(this.portlet.config);
				}
			})
		);
	}

	ngOnDestroy(): void {
		this.subscriptions.forEach((sub) => sub.unsubscribe());
	}

	onMemberEditorOpen(args: any): void {
		// 你可以在这里根据需要修改args来自定义过滤窗口的行为
		// 11247 专门为item data type而设置
		if (args.fieldName === "AccountTypeCode") {
			let res = new Array(5).fill(null);
			const fieldMembers = [...args.fieldMembers];

			for (let i = fieldMembers.length - 1; i >= 0; i--) {
				let index = -1;
				const item = this.itemDataTypeSortArr.find((name, ind) => {
					if (fieldMembers[i].actualText === name) {
						index = ind;
					}
					return fieldMembers[i].actualText === name;
				});
				if (!item) {
					continue;
				}
				const fillItem = fieldMembers.splice(i, 1);
				res[index] = fillItem[0];
			}
			res = res.filter((item) => item) || [];
			args.fieldMembers = [...res, ...fieldMembers];
			setTimeout(() => {
				const ele = document.querySelector(".e-member-editor-dialog");
				if (ele) {
					ele.querySelector(".e-filter-sort").setAttribute(
						"style",
						"display: none"
					);
				}
			});
		}
	}

	private setGridSettings() {
		this.gridSettings = {
			columnWidth: 140,
			rowHeight: 40,
			allowSelection: true,
			selectionSettings: {
				mode: "Cell",
				type: "Multiple",
				cellSelectionMode: "Box",
			},
			columnRender: this.observable.subscribe((args) => {
				this.setColumnsRender(args);
			}) as any,
			// 升级后 默认会有导出样式覆盖，需要手动设置导出标题样式
			excelHeaderQueryCellInfo: this.observable.subscribe((args: any) => {
				// args.style是个ExcelStyle类型
				args.style = {
					bold: true, // 字体加粗
					vAlign: "Center",
					wrapText: false, // 不换行
					indent: 0,
					borders: null, // 不需要border
				};
			}) as any,
			// 升级后 默认会有导出样式覆盖，需要手动设置导出内容样式
			excelQueryCellInfo: this.observable.subscribe((args: any) => {
				// #f486cfff 这里输出的是RGBA 颜色格式， xlsx里不需要透明度,去掉尾部ff
				if (args.style && args.style.backColor) {
					args.style.backColor = args.style.backColor.substring(0, 7);
				}
				let _style: any = {
					bold: false,
					wrapText: false,
					borders: null,
					fontColor: args.style.fontColor,
					backColor: args.style.backColor,
				};
				let colIndex = args.cell.colIndex;
				let rowIndex = args.cell.rowIndex;
				if (this.config.showGrandTotals) {
					// GrandTotal不需要颜色
					if (args.data.length === rowIndex + 1) {
						delete _style.fontColor;
						delete _style.backColor;
					}
				}
				if (args.data[rowIndex][colIndex].formattedText == "") {
					args.value = "";
				}
				args.style = Object.assign(args.style, _style);
				if (args.value === "" && args.style.numberFormat) {
					args.style.numberFormat = null;
				}
				if (this.formatDates && this.formatDates.length) {
					let dateFields = this.formatDates.map((el) => {
						return el.name;
					});
					if (
						(args as any).value &&
						((args as any).cell.colIndex === 0
							? dateFields.includes(
									(args as any).cell.valueSort.axis
							  )
							: dateFields.includes(
									(args as any).cell.actualText
							  ))
					) {
						//Customize the Row headers/Column headers based on your needs
						let headers;
						if ((args as any).cell.colIndex === 0) {
							headers = (args as any).cell.actualText;
						} else {
							// headers = pivotValues[k][j].formattedText;
							headers = (args as any).value;
						}
						if (headers) {
							let date = new Date(headers);

							let quarter = Math.floor(date.getMonth() / 3) + 1;

							let format;

							this.formatDates.map((el) => {
								if ((args as any).cell.colIndex == 0) {
									if (
										el.name ==
										(args as any).cell.valueSort.axis
									)
										format = el.format;
								} else {
									if (
										el.name == (args as any).cell.actualText
									)
										format = el.format;
								}
							});
							(args as any).value = this.getQuarterValue(
								format,
								date,
								quarter
							);
						}
					}
				}
			}) as any,
		} as GridSettings;
	}

	beforeExport(exportData) {
		if (exportData) {
			const keyMap = {};
			this.dataSourceSettings.formatSettings.forEach((data) => {
				if (
					data.format === "#,###,,.0;(#,###,,.0)" ||
					data.format === "#,###,,;(#,###,,)" ||
					data.format === "#,###,,.00;(#,###,,.00)"
				) {
					keyMap[data.name] = true;
				}
			});
			if (
				exportData.dataCollections &&
				exportData.dataCollections.length
			) {
				exportData.dataCollections[0].forEach((row) => {
					row.forEach((cell) => {
						if (keyMap[cell.actualText]) {
							cell.value = cell.actualValue;
						}

						if (
							typeof cell.value === "object" &&
							typeof cell.formattedText === "string"
						) {
							cell.value = cell.formattedText;
						}
					});
				});
			}
		}
	}

	private async getData() {
		this.pageLoading = false;
		let columns = [];
		let values = [];
		let formatSettings = [];
		let rows = [];
		let fieldMapping = [];
		// 清空grandTotals和subTotals
		this.grandTotals = {};
		this.subTotals = {};
		this.config = JSON.parse(this.portlet.config);
		this.setGridSettings();
		if (this.config.fields) {
			if (this.dashboardPorletsService.allFieldsObj[this.portlet.id]) {
				this.configFields =
					this.dashboardPorletsService.setConfigFields(
						this.dashboardPorletsService.allFieldsObj[
							this.portlet.id
						],
						this.config.fields
					);
			} else {
				this.configFields = [...this.config.fields];
			}
		}

		this.Pivot_Data = this.dashboardPorletsService.getResultByDataTable(
			this.portlet,
			false,
			false,
			this.dashboard.id
		);

		this.orderByColumns = this.dashboardPorletsService.getOrderByColumnsNew(
			this.portlet.figureCode,
			this.dashboard
		);

		this.Pivot_Data = DataUtil.parse.parseJson(this.Pivot_Data);
		if (this.Pivot_Data && this.Pivot_Data.length > 0) {
			// 移除列名和数据key不匹配的项
			this.getexcludeFields(this.configFields, this.Pivot_Data[0]);
			if (!this.allowedCalculatedFields.length) {
				this.allowedCalculatedFields = Object.keys(this.Pivot_Data[0]);
			}
			for (let item of this.configFields) {
				// 字段分组 https://ej2.syncfusion.com/angular/documentation/pivotview/field-list?search=fieldMapping#group-fields-under-desired-folder-name
				fieldMapping.push({
					name: item.colName,
					caption: item.addtionName
						? `${item.langValue} ${item.addtionName}`
						: item.langValue
						? item.langValue
						: this.translation[item.langCode] || item.langCode,

					dataType: item.dataType,
				});
			}
		}
		if (this.configFields) {
			this.percentNumFields = [];
			this.formatDates = [];
			this.zeroFormatData.hgList = [];
			this.zeroFormatData.emptyList = [];
			this.millionFields = [];
			this.configFields.map((el) => {
				// SMP2-2486 & percentNum的format问题
				if (el.dataType == "percentNum") {
					this.percentNumFields.push(el.colName);
				}
				if (
					el.format &&
					el.format.length &&
					el.format[0].formatChecked &&
					[2, 5, 8, 11, 14, 17].includes(el.format[0].selectedFormat)
				)
					this.zeroFormatData.hgList.push(el.colName);
				if (
					el.format &&
					el.format.length &&
					el.format[0].formatChecked &&
					[3, 6, 9, 12, 15, 18].includes(el.format[0].selectedFormat)
				)
					this.zeroFormatData.emptyList.push(el.colName);
				//  pivotTableformatPercent 百分比也有10,11,12 但是它是显示0.00x的格式，所以得排除
				if (
					el.dataType !== "percent" &&
					el.format &&
					el.format.length &&
					el.format[0].formatChecked &&
					[10, 11, 12, 13, 14, 15, 16, 17, 18].includes(
						el.format[0].selectedFormat
					)
				)
					this.millionFields.push(el.colName);
				if (
					el.dataType === "number" &&
					(!el.format ||
						(el.format &&
							el.format.length &&
							!el.format[0].formatChecked))
				) {
					const formatData = {
						name: el.colName,
						//SMP2-3026 and SMP2-3059
						format:
							el.colName !== "PortInvStk" &&
							el.colName !== "PortFdInvStk"
								? this.dashboardPorletsService.formatNumber(
										el.dp
								  )
								: "##0.#######0",
						useGrouping: true,
					};

					formatSettings.push(formatData);
				}
				if (
					(el.dataType === "percent" ||
						el.dataType === "percentNum") &&
					(!el.format ||
						(el.format &&
							el.format.length &&
							!el.format[0].formatChecked))
				) {
					const formatData = {
						name: el.colName,
						format: this.dashboardPorletsService.formatPercent(
							el.dp
						),
					};
					formatSettings.push(formatData);
				}
				if (
					el.dataType === "multiple" &&
					(!el.format ||
						(el.format &&
							el.format.length &&
							!el.format[0].formatChecked))
				) {
					const formatData = {
						name: el.colName,
						format: this.dashboardPorletsService.formatMultiple(
							el.dp
						),
					};
					formatSettings.push(formatData);
				}
				if (el.dataType === "datetime" || el.dataType === "date") {
					let format = "";
					if (
						el.format &&
						el.format.length &&
						el.format[0].formatChecked
					) {
						if (el.format[0].dateType == "Quarter") {
							let format_ = el.format[0].selectedFormatDisplay;
							let formatInfo = this.quarterFormat.filter(
								(qur) => qur.value == format_
							);
							if (formatInfo.length) {
								format = formatInfo[0].format;
							} else {
								const formatData = {
									name: el.colName,
									format: format_,
									type: "date",
								};
								this.formatDates.push(formatData);
							}
						} else if (el.format[0].dateType == "Date") {
							let fromIdx =
								el.format[0].selectedFormatDisplay.indexOf("(");
							let toIdx =
								el.format[0].selectedFormatDisplay.indexOf(")");
							let format_ =
								el.format[0].selectedFormatDisplay.slice(
									fromIdx + 1,
									toIdx
								);
							switch (format_) {
								case "DD/MM/YYYY":
									format = "dd/MM/yyyy";
									break;
								case "DD/MM/YY":
									format = "dd/MM/yy";
									break;
								case "MM/DD/YYYY":
									format = "MM/dd/yyyy";
									break;
								case "MM/DD/YY":
									format = "MM/dd/yy";
									break;
								case "YYYY-MM-DD":
									format = "yyyy-MM-dd";
									break;
								case "YY-MM-DD":
									format = "yy-MM-dd";
									break;
								case "DD-MM-YYYY":
									format = "dd-MM-yyyy";
									break;
								case "DD-MM-YY":
									format = "dd-MM-yy";
									break;
								case "MM-DD-YYYY":
									format = "MM-dd-yyyy";
									break;
								case "MM-DD-YY":
									format = "MM-dd-yy";
									break;
								case "MMM DD, YYYY":
									format = "MMM dd, yyyy";
									break;
								case "DD-MMM-YYYY":
									format = "dd-MMM-yyyy";
									break;
								default:
									break;
							}
						}
					}
					if (!format) {
						const formatData = {
							name: el.colName,
							format: this.datePipeFormat,
							type: "date",
						};
						formatSettings.push(formatData);
					} else {
						const formatData = {
							name: el.colName,
							format: format,
							type: "date",
						};

						formatSettings.push(formatData);
					}
				}
			});
		}
		//calculatedFieldSettings format push to formatSettings
		if (
			this.config.calculatedFieldSettings &&
			this.config.calculatedFieldSettings.length > 0
		) {
			this.config.calculatedFieldSettings.map((el) => {
				if (el.formatString !== "") {
					for (let i = formatSettings.length - 1; i >= 0; i--) {
						if (formatSettings[i].name === el.name) {
							formatSettings.splice(i, 1);
						}
					}
					formatSettings.push({
						name: el.name,
						format: el.formatString,
					});
				}
			});
		}
		let series = this.config.yaxis.series;
		if (series) {
			for (let item of series) {
				const value = {
					name: item.colName,
					caption: this.getCaptionByName(item.colName) || item.title,
					type: item.calMethod,
				};
				values.push(value);
			}
		}
		let groups = this.config.xaxis.groups;
		if (groups) {
			for (let gitem of groups) {
				const field = this.configFields.filter(
					(el) => el.colName === gitem.name
				);
				if (field.length > 0) {
					gitem.showSubTotals = field[0].showSubTotals;
					gitem.caption =
						field[0].langValue ||
						this.translation[field[0].langCode] ||
						gitem.caption ||
						field[0].langCode;
				}
				rows.push(gitem);
			}
		}
		if (this.config.columnGroup && this.config.columnGroup.length) {
			for (let item of this.config.columnGroup) {
				const field = this.configFields.filter(
					(el) => el.colName === item.name
				);
				if (field.length > 0) {
					item.showSubTotals = field[0].showSubTotals;
					item.caption =
						field[0].langValue ||
						this.translation[field[0].langCode] ||
						field[0].langCode ||
						item.caption;
				}
				columns.push(item);
			}
		}
		let conditionalFormatSettings = [];
		this.configFields.forEach((field) => {
			if (field.format && field.format.length) {
				if (field.format[0].fontSettingChecked) {
					let conditionalFormatObj = {
						applyGrandTotals: true,
						measure: "",
						value1: null,
						value2: null,
						conditions: "",
						style: {
							backgroundColor: "",
							color: "",
							fontFamily: "",
							fontSize: "",
						},
					};
					let negaConditionalFormatObj = {
						applyGrandTotals: true,
						measure: "",
						value1: null,
						value2: null,
						conditions: "",
						style: {
							backgroundColor: "",
							color: "",
							fontFamily: "",
							fontSize: "",
						},
					};
					// font setting start
					negaConditionalFormatObj.measure =
						field.format[0].selectedField;
					conditionalFormatObj.measure =
						field.format[0].selectedField;

					if (
						field.format[0].formatChecked &&
						field.format[0].compareSelect
					) {
						this.setCompareConditional(
							negaConditionalFormatObj,
							conditionalFormatObj,
							field.format[0]
						);
					} else {
						delete conditionalFormatObj.value2;
						delete negaConditionalFormatObj.value2;
						negaConditionalFormatObj.value1 = 0;
						negaConditionalFormatObj.conditions = "LessThan";
						conditionalFormatObj.value1 = 0;
						conditionalFormatObj.conditions = "GreaterThan";
						this.setFontSettingConditional(
							negaConditionalFormatObj,
							field.format[0],
							-1
						);
						this.setFontSettingConditional(
							conditionalFormatObj,
							field.format[0],
							1
						);
					}
					conditionalFormatSettings.push(negaConditionalFormatObj);
					conditionalFormatSettings.unshift(conditionalFormatObj);
					// font setting end
				}
				let formatSettingsObj = {
					name: "",
					format: "",
				};
				if (field.format[0].formatChecked) {
					formatSettingsObj.name = field.format[0].selectedField;
					formatSettingsObj.format =
						this.dashboardPorletsService.pivotTableformatNumber(
							field.format[0].selectedFormat
						);
					switch (field.format[0].dataType) {
						case "number":
							formatSettingsObj.format =
								this.dashboardPorletsService.pivotTableformatNumber(
									field.format[0].selectedFormat
								);
							break;
						case "integer":
							formatSettingsObj.format =
								this.dashboardPorletsService.pivotTableformatInteger(
									field.format[0].selectedFormat
								);
							break;
						case "percentNum":
						case "percent":
							formatSettingsObj.format =
								this.dashboardPorletsService.pivotTableformatPercent(
									field.format[0].selectedFormat
								);
							break;
						case "multiple":
							formatSettingsObj.format =
								this.dashboardPorletsService.pivotTableformatMultiple(
									field.format[0].selectedFormat
								);
							break;
						case "date":
						case "datetime":
							let format = "";
							if (field.format && field.format.length) {
								if (field.format[0].dateType == "Quarter") {
									format =
										field.format[0].selectedFormatDisplay;
								} else if (field.format[0].dateType == "Date") {
									let fromIdx =
										field.format[0].selectedFormatDisplay.indexOf(
											"("
										);
									let toIdx =
										field.format[0].selectedFormatDisplay.indexOf(
											")"
										);
									format =
										field.format[0].selectedFormatDisplay.slice(
											fromIdx + 1,
											toIdx
										);
								}
							}
							if (format) {
								formatSettingsObj = {
									name: field.colName,
									format: "",
								};
								// field.dataType = "string";
							} else {
								formatSettingsObj.format = this.datePipeFormat;
								formatSettingsObj["type"] = "date";
							}
							break;
						default:
							break;
					}
				}
				if (
					field.format[0].dataType !== "string" &&
					formatSettingsObj.format
				) {
					formatSettings.push(formatSettingsObj);
				}
			}
		});
		this.customCalculatedFields = this.config.customCalculatedFields
			? this.config.customCalculatedFields
			: [];

		// SMP2-4582 AGIC - Dashboard item sequence
		let isExistSeq = false;
		let sortSettings = this.config.sortSettings || [];
		if (
			this.Pivot_Data &&
			this.Pivot_Data[0] &&
			this.Pivot_Data[0].Seq !== null
		) {
			// 取消Name的默认排序，根据Seq来排序
			sortSettings.push({ name: "Name", order: "None" });
			isExistSeq = true;
		}
		let filterSettings = this.dashboardPorletsService.checkFilterSettings(
			this.config,
			this.configFields,
			this.Pivot_Data
		);
		let nameFilter = filterSettings.find((x) => x.name === "Name");
		// 存在 Name的filter时，会按照默认排序，需要对Name进行Seq排序处理
		if (isExistSeq && nameFilter && rows.some((x) => x.name === "Name")) {
			let items = nameFilter.items; // 拿到当前排序，默认A-Z
			let seqArr = [];
			items.forEach((name) => {
				let obj = this.Pivot_Data.find((x) => x.Name === name);
				let item: any = {
					name: name,
					seq: obj.Seq,
				};
				seqArr.push(item);
			});
			seqArr.sort((a, b) => a.seq - b.seq);
			nameFilter.items = seqArr.map((x) => x.name);
		}

		const allFields =
			this.dashboardPorletsService.allFieldsObj[this.portlet.id];
		if (allFields) {
			values.forEach((value) => {
				const item = allFields.find(
					(field) => field.colName === value.name
				);
				if (item) {
					value.caption =
						(item.format &&
							item.format.length &&
							item.format[0].displayName) ||
						item.langValue ||
						this.translation[item.langCode] ||
						item.langCode;
				}
			});
		}
		let hasItemDataType = false;
		if (this.Pivot_Data) {
			this.Pivot_Data.map((data) => {
				if (data["AccountTypeCode"]) {
					hasItemDataType = true;
				}
				rows.forEach((row) => {
					if (data[row.name] === "") {
						data[row.name] = "null";
					}
				});
			});
		}
		if (hasItemDataType) {
			sortSettings.push({
				name: "AccountTypeCode",
				order: "Ascending",
				membersOrder: [...this.itemDataTypeSortArr],
			});
		}
		this.config.filters.forEach((filter) => {
			filter.caption =
				this.getCaptionByName(filter.name) || filter.caption;
		});
		this.dataSourceSettings = {
			dataSource: this.Pivot_Data || [],
			rows: rows || [],
			columns: columns || [],
			values: values || [],
			filters: this.config.filters,
			filterSettings: filterSettings,
			excludeFields: this.excludeFields,
			formatSettings: formatSettings,
			conditionalFormatSettings: conditionalFormatSettings,
			// 用于收起展开指定层级, 这玩意只能展开第一层,
			// 必须设定expandAll 为false（默认是false）， 这样子才能实现只展开两层
			// drilledMembers,
			expandAll: true,
			enableSorting: true,
			fieldMapping: fieldMapping,
			calculatedFieldSettings: this.config.calculatedFieldSettings,
			sortSettings: sortSettings,
			// groupSettings: this.config.groupSettings,
			valueSortSettings: this.config.valueSortSettings,
			showGrandTotals: this.config.showGrandTotals,
			showRowGrandTotals: this.config.showRowGrandTotals,
			showColumnGrandTotals: this.config.showColumnGrandTotals,
			showSubTotals: this.config.showSubTotals,
			showRowSubTotals: this.config.showRowSubTotals,
			showColumnSubTotals: this.config.showColumnSubTotals,
		};
		console.log("this.dataSourceSettings", this.dataSourceSettings);

		this.ref.markForCheck();
	}

	getCaptionByName(nameString) {
		if (!nameString) return "";
		const field = this.configFields.find((el) => el.colName === nameString);

		return field
			? field.langValue ||
					this.translation[field && field.langCode] ||
					field.langCode
			: "";
	}

	public afterPopulate(args: EnginePopulatedEventArgs): void {
		this.tempSubtotals = [];
		this.grandTotals = {};
		this.subTotals = {};
		let tempshowArray = [];
		this.config.yaxis.series.forEach((item) => {
			if (
				item.hasOwnProperty("showSubTotals") &&
				item.hasOwnProperty("showGrandTotals")
			) {
				tempshowArray.push({
					name: item.colName,
					calMethod: item.calMethod,
					showSubTotals: item.showSubTotals,
					showGrandTotals: item.showGrandTotals,
				});
			} else {
				if (item.hasOwnProperty("showGrandTotals")) {
					tempshowArray.push({
						name: item.colName,
						calMethod: item.calMethod,
						showGrandTotals: item.showGrandTotals,
					});
				}
				if (item.hasOwnProperty("showSubTotals")) {
					tempshowArray.push({
						name: item.colName,
						calMethod: item.calMethod,
						showSubTotals: item.showSubTotals,
					});
				}
			}
		});

		if (this.fieldlistObj && this.pivotObj) {
			this.config.columnGroup = [];
			this.config.xaxis.groups = [];
			this.config.yaxis.series = [];
			this.config.filters = [];
			this.config.filterSettings = [];
			this.config.calculatedFieldSettings = [];
			let groupSettings = this.getDataSourceSettingsProp(
				this.fieldlistObj,
				"groupSettings"
			);
			let columns = this.getDataSourceSettingsProp(
				this.fieldlistObj,
				"columns"
			);
			let rows = this.getDataSourceSettingsProp(
				this.fieldlistObj,
				"rows"
			);
			let filters = this.getDataSourceSettingsProp(
				this.fieldlistObj,
				"filters"
			);
			let filterSettings = this.getDataSourceSettingsProp(
				this.fieldlistObj,
				"filterSettings"
			);
			let values = this.getDataSourceSettingsProp(
				this.fieldlistObj,
				"values"
			);
			let sortSettings = this.getDataSourceSettingsProp(
				this.fieldlistObj,
				"sortSettings"
			);
			let calculatedFieldSettings = this.getDataSourceSettingsProp(
				this.fieldlistObj,
				"calculatedFieldSettings"
			);
			if (groupSettings.length === 0) {
				for (let column of columns) {
					this.config.columnGroup.push({
						name: column.name,
						caption:
							this.getCaptionByName(column.name) ||
							column.caption,
					});
				}
			} else {
				//If there is a group, first filter the columns of the group field, and then only save the last one
				for (let column of columns) {
					if (!startsWith(column.name, groupSettings[0].name + "_")) {
						this.config.columnGroup.push({
							name: column.name,
							caption:
								column.name === groupSettings[0].name
									? ""
									: this.getCaptionByName(column.name) ||
									  column.caption,
						});
					}
				}
			}
			for (let row of rows) {
				this.config.xaxis.groups.push({
					name: row.name,
					caption: this.getCaptionByName(row.name) || row.caption,
				});
			}
			for (let filter of filters) {
				this.config.filters.push({
					name: filter.name,
					caption:
						this.getCaptionByName(filter.name) || filter.caption,
				});
			}
			if (this.filterSettings && this.filterSettings.length > 0) {
				args.dataSourceSettings.filterSettings = this.filterSettings;
				this.config.filterSettings = this.filterSettings;
				delete this.filterSettings;
			} else {
				this.config.filterSettings = filterSettings;
			}
			for (let value of values) {
				let seriesData;
				let tempShowObj;
				let filterTempshowArray = [];
				if (tempshowArray.length) {
					filterTempshowArray = tempshowArray.filter(
						(item) =>
							item.name === value.name &&
							item.calMethod === value.type
					);
					if (filterTempshowArray.length) {
						tempShowObj = filterTempshowArray[0];
						if (
							tempShowObj.hasOwnProperty("showSubTotals") &&
							tempShowObj.hasOwnProperty("showGrandTotals")
						) {
							seriesData = {
								colName: value.name,
								calMethod: value.type,
								title: value.caption,
								showSubTotals: tempShowObj.showSubTotals,
								showGrandTotals: tempShowObj.showGrandTotals,
							};
						} else {
							if (tempShowObj.hasOwnProperty("showGrandTotals")) {
								seriesData = {
									colName: value.name,
									calMethod: value.type,
									title: value.caption,
									showGrandTotals:
										tempShowObj.showGrandTotals,
								};
							}
							if (tempShowObj.hasOwnProperty("showSubTotals")) {
								seriesData = {
									colName: value.name,
									calMethod: value.type,
									title: value.caption,
									showSubTotals: tempShowObj.showSubTotals,
								};
							}
						}
					}
				}
				if (!seriesData) {
					seriesData = {
						colName: value.name,
						title: value.caption,
						calMethod: value.type,
					};
				}
				this.config.yaxis.series.push(seriesData);
			}
			for (let calculate of calculatedFieldSettings) {
				const calculateData = {
					name: calculate.name,
					formula: calculate.formula,
					formatString:
						calculate.formatString === ""
							? "N2"
							: calculate.formatString,
				};
				this.config.calculatedFieldSettings.push(calculateData);
			}
			this.config.customCalculatedFields = this.customCalculatedFields;
			this.config.sortSettings = sortSettings;
			this.config.groupSettings = groupSettings;
			this.fieldlistObj.updateView(this.pivotObj);
		}
		this.portlet.config = JSON.stringify(this.config);
		//remove the sort
		if (this.pivotObj.dataSourceSettings.sortSettings.length > 0) {
			this.previousSort = this.fieldlistObj.lastSortInfo;
			(this.fieldlistObj as any).lastSortInfo = [];
		}
	}

	public afterEnginePopulate(args: any) {
		if (!Browser.isDevice && this.fieldlistObj && this.pivotObj) {
			this.config.groupSettings = this.getDataSourceSettingsProp(
				this.pivotObj,
				"groupSettings"
			);
			this.portlet.config = JSON.stringify(this.config);
			if (this.fieldlistObj) this.fieldlistObj.update(this.pivotObj);
			this.pivotObj.grid.queryCellInfo = this.queryCell.bind(this);
			this.pivotObj.grid.headerCellInfo = this.headerCell.bind(this);
			// SMP2-3929 rollback
			// if (!this.isApplyIRR)
			// 	this.getCalculationResultByDashboardDataTableId();
		}
		if (this.Pivot_Data && this.Pivot_Data.length) {
			setTimeout(() => {
				this.enginePopulated(args);
			}, 1500);
		}
	}

	private getDataSourceSettingsProp(obj, key) {
		let prop = null;
		if (obj && obj.dataSourceSettings) {
			prop = obj.dataSourceSettings[key];
			if (
				Object.prototype.toString.call(prop) === "[object Array]" &&
				prop.length > 0
			) {
				prop = prop.map((item) => item.properties || item);
			}
		}
		return prop;
	}

	public enginePopulating(args) {
		this.grandTotals = {};
		this.subTotals = {};
		this.allDataValue = [];
		// if (args.dataSourceSettings.sortSettings.length) {
		// 	for (
		// 		let i = 0;
		// 		i < args.dataSourceSettings.sortSettings.length;
		// 		i++
		// 	) {
		// 		if (
		// 			this.fieldlistObj.lastSortInfo &&
		// 			this.fieldlistObj.lastSortInfo.name ===
		// 				args.dataSourceSettings.sortSettings[i].name &&
		// 			this.fieldlistObj.lastSortInfo.order === "Ascending" &&
		// 			!(
		// 				this.fieldlistObj.lastSortInfo.name ===
		// 					this.previousSort.name &&
		// 				this.previousSort.order === "None"
		// 			)
		// 		) {
		// 			args.dataSourceSettings.sortSettings[i].order = "None";
		// 		} else if (
		// 			this.previousSort &&
		// 			this.fieldlistObj.lastSortInfo &&
		// 			this.fieldlistObj.lastSortInfo.name ===
		// 				this.previousSort.name &&
		// 			this.previousSort.order === "Ascending"
		// 		) {
		// 			args.dataSourceSettings.sortSettings[i].order = "Ascending";
		// 		}
		// 	}
		// }
	}

	public cellClick(args) {
		if (args.currentCell.classList.contains("e-headercell")) {
			this.flag = true;
		}
		// 清除排序
		if (
			this.pivotObj.dataSourceSettings.valueSortSettings.sortOrder &&
			this.pivotObj.dataSourceSettings.valueSortSettings.headerText &&
			this.pivotObj.dataSourceSettings.valueSortSettings.sortOrder ===
				"Descending" &&
			args.data.valueSort &&
			this.pivotObj.dataSourceSettings.valueSortSettings.headerText ===
				args.data.valueSort.levelName
		) {
			this.pivotObj.setProperties(
				{
					dataSourceSettings: {
						valueSortSettings: {
							sortOrder: "Descending",
							headerText: "",
						},
					},
				},
				true
			);
			if (this.pivotObj) this.pivotObj.refreshData();
			this.flag = false;
			this.config.valueSortSettings = {};
			this.portlet.config = JSON.stringify(this.config);
		}
	}

	private queryCell(args: any): void {
		(this.pivotObj.renderModule as any).rowCellBoundEvent(args);
		let rowIndex = Number(args.cell.getAttribute("index"));
		// 新版本26.x中 aria-colindex 会比旧版本v20.x 多1
		let colIndex = parseInt(args.cell.getAttribute("aria-colindex")) - 1;
		if (
			!this.pivotObj.dataSourceSettings.conditionalFormatSettings.length
		) {
			if (args.data && args.data[0].formattedText === "Grand Total") {
				args.cell.classList.add("grand-class");
			} else {
				args.cell.classList.add(
					rowIndex % 2 ? "odd-class" : "even-class"
				);
			}
		} else {
			let measureArr =
				this.pivotObj.dataSourceSettings.conditionalFormatSettings.map(
					(obj) => {
						return obj.measure;
					}
				);
			if (
				measureArr.includes(args.data[colIndex].actualText) &&
				args.data[colIndex].style
			) {
				args.cell.style.cssText += `background-color: ${args.data[colIndex].style.backgroundColor} !important`;
			}
			if (args.data && args.data[0].formattedText === "Grand Total")
				args.cell.classList.add("e-customclass");
		}

		if (args.data && args.data[0].formattedText === "Grand Total") {
			args.cell.classList.add("grand-class");
		} else {
			if (rowIndex % 2) {
				args.cell.classList.add("odd-class");
			} else {
				args.cell.classList.add("even-class");
			}
		}

		//get sorting data
		if (this.flag) {
			this.flag = false;
			this.config.valueSortSettings =
				this.pivotObj.dataSourceSettings.valueSortSettings[
					"properties"
				];
			this.portlet.config = JSON.stringify(this.config);
		}
		//customize the header text
		if (this.pivotObj.dataSourceSettings.rows.length === 0) {
			if (
				args.data &&
				args.data[colIndex] &&
				args.data[colIndex].axis === "row"
			) {
				args.cell.querySelector(".e-cellvalue").innerText =
					args.data[colIndex].formattedText;
			}
		}

		// SMP2-2912 subtotal字体加粗
		if (
			this.pivotObj.dataSourceSettings.rows.length &&
			args.data[colIndex] &&
			args.data[0].level !==
				this.pivotObj.dataSourceSettings.rows.length - 1 &&
			args.data[colIndex].rowHeaders !== "" &&
			args.data[colIndex].axis == "value"
		) {
			args.cell.classList.add("e-customclass");
		}
	}

	private headerCell(args: any): void {
		(this.pivotObj.renderModule as any).columnCellBoundEvent(args);
		if (this.pivotObj.dataSourceSettings.columns.length === 0) {
			let node = args.node.querySelector(
				".e-headercelldiv .e-headertext"
			);
			if (node) node.innerText = args.cell.column.headerText;
		}
		const textAlign = args.cell.column.textAlign;
		args.cell.column.headerTextAlign = textAlign;
		args.node.style.textAlign = textAlign === "Right" ? "right" : "left"; // Align right for numeric columns
		if (textAlign === "Right") {
			args.node.classList.add("header-align-right");
		}
		this.ref.markForCheck();
	}

	public dataBound(e) {
		if (this.isInit) {
			this.isInit = false;
		}
		this.grandTotals = {};
		this.subTotals = {};
		if (this.pivotObj.grid) {
			this.pivotObj.grid.resizeStop = this.resizeStop.bind(this);
		}
		if (this.pivotObj) {
			var index = [];
			// Get the empty row headers here.
			var emptyRowHeader: any = document.querySelectorAll(
				'td[aria-label=" column header "]'
			);
			for (var ele of emptyRowHeader) {
				if (ele) {
					index.push(ele.getAttribute("index"));
					// Remove all the empty row headers here.
					ele.closest("tr").remove();
				}
			}
			for (var i = 0; i < index.length; i++) {
				// Get the empty values here.
				var emptyValues = this.pivotObj.element.querySelectorAll(
					`td[index="${index[i]}"]`
				);
				if (emptyValues[0]) {
					// Remove all the empty value rows here.
					emptyValues[0].closest("tr").remove();
				}
			}
		}
		if (
			this.fieldlistObj &&
			this.fieldlistObj.pivotButtonModule &&
			this.fieldlistObj.pivotButtonModule.menuOption
		) {
			(
				this.fieldlistObj.pivotButtonModule.menuOption as any
			).stringAggregateTypes = [
				"Count",
				"DistinctCount",
				"First",
				"Last",
			];
		}
		if (
			this.pivotObj.pivotButtonModule &&
			this.pivotObj.pivotButtonModule.menuOption
		) {
			(
				this.pivotObj.pivotButtonModule.menuOption as any
			).stringAggregateTypes = [
				"Count",
				"DistinctCount",
				"First",
				"Last",
			];
		}
		let allSummaryType = ALL_AGGREGATE_TYPES as any;
		this.pivotObj.getAllSummaryType = function () {
			return allSummaryType;
		};
		if (this.fieldlistObj) {
			this.fieldlistObj.aggregateTypes = allSummaryType;
			this.fieldlistObj.getAllSummaryType = function () {
				return allSummaryType;
			};
		}
		this.setValueItemData();
	}

	private setValueItemData() {
		setTimeout(() => {
			const fieldDom = this.fieldlistObj.fieldListSpinnerElement;
			this.dataSourceSettings.values.forEach((value: any) => {
				if (value.type !== "First" && value.type !== "Last") {
					return;
				}
				const valuesDom = fieldDom.querySelector(
					`.e-values .${value.name} .e-pvt-btn-content`
				);
				if (
					valuesDom.innerHTML !== `${value.type} of ${value.caption}`
				) {
					valuesDom.innerHTML = `${value.type} of ${value.caption}`;
				}
			});
		});
	}

	private calculatedCellSets(args, curFields) {
		let matchFields = curFields["matchFields"];
		let formula = curFields["formula"];
		let value = 0;
		let rows = this.pivotObj.dataSourceSettings.rows;
		let invalidTypes = ["string", "nvarchar", "date", "datetime"];
		let isInvalid = matchFields.some((f) =>
			invalidTypes.includes(
				this.configFields.filter((el) => el.colName === f.matchWord)[0][
					"dataType"
				]
			)
		);
		let currentrowCellType = args.rowCellType;
		if (isInvalid) return "-";
		if (
			args.rowCellType === "subTotal" ||
			args.rowCellType === "grandTotal"
		) {
			let childHeaders = [];
			let sum = 0;
			let cloneCellSets = cloneDeep(args.cellSets);
			let groupNameArrays = [];
			for (let index = args.row.level; index < rows.length; index++) {
				groupNameArrays.push(rows[index].name);
			}
			for (let i = 0; i < cloneCellSets.length; i++) {
				let values = [];
				let header = groupNameArrays
					.map((name) => {
						values.push(cloneCellSets[i][name]);
						return cloneCellSets[i][name];
					})
					.join("-");
				if (!(childHeaders as any).includes(header)) {
					childHeaders.push(header);
					let filterObj: any = {};
					groupNameArrays.map(
						(name, i) => (filterObj[name] = values[i])
					);
					args.cellSets = _filter(cloneCellSets, filterObj);
					args.rowCellType = "value";
					sum += this.calculatedValues(args, matchFields, formula);
				}
			}
			args.rowCellType = currentrowCellType;

			// 暂存当前SubTotal， 用于收缩时读取
			let prefixHeader = this.getCalcHeader(args, formula);
			this.updateTempSubtotals(prefixHeader, sum);
			return sum;
		} else if (args.rowCellType === "value") {
			if (args.row.hasChild) {
				// collapse 读取SubTotal
				let header = this.getCalcHeader(args, formula);
				let index = this.tempSubtotals.findIndex(
					(item) => item.rowName === header
				);
				if (index > -1) {
					value = this.tempSubtotals[index].rowValue;
				}
			} else {
				// expand
				value = this.calculatedValues(args, matchFields, formula);
			}
		}
		return value;
	}

	actionFailure(args: PivotActionFailureEventArgs): void {
		if (args.actionName == "Drill down" || args.actionName == "Drill up") {
			// Triggers when the current UI action fails to achieve the desired result.
		}
	}

	private getCalcHeader(args, formula?) {
		let header = "";
		let rows = this.pivotObj.dataSourceSettings.rows;
		let groupNameArrays = [];
		for (let index = 0; index < args.row.level; index++) {
			groupNameArrays.push(rows[index].name);
		}
		header = groupNameArrays.length
			? groupNameArrays
					.map((name) => {
						return args.cellSets[0][name];
					})
					.join("-") +
			  "-" +
			  args.row.actualText
			: args.row.actualText;
		if (formula) header += "___" + formula;
		return header;
	}

	private updateTempSubtotals(rowName, rowValue) {
		let index = this.tempSubtotals.findIndex(
			(item) => item.rowName === rowName
		);
		let temp: any = {};
		temp.rowName = rowName;
		temp.rowValue = rowValue;
		if (index > -1) {
			this.tempSubtotals.splice(index, 1, temp);
		} else {
			this.tempSubtotals.push(temp);
		}
	}

	private calculatedValues(args, matchFields, formula) {
		if (matchFields.length) {
			let calculedMatchFields = matchFields.map((f) => {
				switch (f.matchMethod) {
					case "First":
					case "Last":
						f.replaceValue = this.calculatedFistLast(
							args,
							f.matchMethod,
							f.matchWord
						);
						break;
					case "Max":
						f.replaceValue = maxBy(args.cellSets, (o) =>
							Number(o[f.matchWord])
						)[f.matchWord];
						break;
					case "Min":
						f.replaceValue = minBy(args.cellSets, (o) =>
							Number(o[f.matchWord])
						)[f.matchWord];
						break;
					case "Sum":
						f.replaceValue = sumBy(args.cellSets, (o) =>
							Number(o[f.matchWord])
						);
						// SMP2-4094 Unicorn - L3 Adjusted NAV value issues
						f.replaceValue =
							f.replaceValue && f.replaceValue.toFixed(10);
						break;
					case "Avg":
						f.replaceValue = meanBy(args.cellSets, (o) =>
							Number(o[f.matchWord])
						);
						break;
					default:
						break;
				}
				return f;
			});
			let resultFormula = formula;
			if (calculedMatchFields.length) {
				for (let i = 0; i < calculedMatchFields.length; i++) {
					resultFormula = resultFormula.replace(
						calculedMatchFields[i].matchStr,
						"(" + calculedMatchFields[i].replaceValue + ")"
					);
				}
			}
			try {
				let result = new Function(
					"return " + resultFormula.replace(/[^-<>?:()\d/*+.]/g, "")
				)();
				if (isNaN(result) || !isFinite(result)) {
					return 0;
				} else {
					return result;
				}
			} catch (error) {
				return NaN;
			}
		}
		return 0;
	}

	totalFormatted = {};
	public aggregateCellInfo(args) {
		let asOfDate = this.pbf.time(this.dashboard.asOfDate);
		// if calculated field
		if (args.aggregateType == "CalculatedField") {
			for (let i = 0; i < this.customCalculatedFields.length; i++) {
				if (args.fieldName == this.customCalculatedFields[i].name) {
					args.value = this.calculatedCellSets(
						args,
						this.customCalculatedFields[i]
					);
				}
			}
		}

		if (
			[
				"CalculateIRR",
				"CalculateIRRBeforeCarried",
				"CalculateIRRIRRDate",
				"CalculateIRRMTD",
				"CalculateIRRQTD",
				"CalculateIRRYTD",
			].includes(args.aggregateType)
		) {
			// console.log("==========================");
			// console.log("args:", args);
			let valueField;
			let dateField;
			let startDate;
			let endDate;
			switch (args.aggregateType) {
				case "CalculateIRR":
					valueField = "IRRAdjValue";
					dateField = "IRRDate";
					break;
				case "CalculateIRRMTD":
					startDate = moment(asOfDate)
						.startOf("month")
						.format("YYYY-MM-DD");
					endDate = moment(asOfDate).format("YYYY-MM-DD");
					valueField = "IRRAdjValue";
					dateField = "IRRDate";
					break;
				case "CalculateIRRQTD":
					startDate = moment(asOfDate)
						.startOf("quarter")
						.format("YYYY-MM-DD");
					endDate = moment(asOfDate).format("YYYY-MM-DD");
					valueField = "IRRAdjValue";
					dateField = "IRRDate";
					break;
				case "CalculateIRRYTD":
					startDate = moment(asOfDate)
						.startOf("year")
						.format("YYYY-MM-DD");
					endDate = moment(asOfDate).format("YYYY-MM-DD");
					valueField = "IRRAdjValue";
					dateField = "IRRDate";
					break;
				case "CalculateIRRIRRDate":
					valueField = "IRRAdjValue";
					dateField = "CalculateIRRDate";
					break;
				case "CalculateIRRBeforeCarried":
					valueField = "IRRAdjValueBeforeCarry";
					dateField = "IRRDate";
					break;
				default:
					break;
			}
			let NAVAdj = 0;
			let values = [];
			let beforeStartNAVAdj = 0; // 存储上一个阶段的NAVAdj总和
			let beforeStartValues = []; // 存储上一个阶段的累计集合 (只是为了打印，没有实际用途)
			let field = this.configFields.filter(
				(el) =>
					el.colName ===
					this.dashboardPorletsService.getAggregateType(
						args.aggregateType
					)
			);
			for (let i = 0; i < args.cellSets.length; i++) {
				const data = {
					amount: args.cellSets[i]["IRRAmount"],
					date:
						this.pbf.time(args.cellSets[i][dateField]) ===
						"Invalid date"
							? asOfDate
							: this.pbf.time(args.cellSets[i][dateField]),
				};
				// SMP2-16920
				// If IRR Date > Dashboard report date = Takes as of dashboard report date
				if (
					args.aggregateType === "CalculateIRRIRRDate" &&
					asOfDate < this.pbf.time(args.cellSets[i][dateField])
				) {
					data.date = asOfDate;
				}
				NAVAdj += args.cellSets[i][valueField];
				// SMP2-17219 MTD QTD YTD IRR
				if (startDate && endDate) {
					if (moment(data.date).isBefore(startDate)) {
						data[valueField] = args.cellSets[i][valueField];
						beforeStartValues.push(data);
						beforeStartNAVAdj += data[valueField];
					}
					if (
						!moment(data.date).isBetween(
							startDate,
							endDate,
							null,
							"[]"
						)
					) {
						continue;
					}
				}
				if (data.amount != 0) {
					values.push(data);
				}
			}
			if (NAVAdj > 0.0001 || NAVAdj < -0.0001) {
				values.push({
					amount: NAVAdj,
					date: asOfDate,
				});
			}
			values = sortBy(values, "date");
			// 如果是MTD,QTD,YTD 则需要把当前阶段以前的所有数据进行汇总，加入计算
			if (startDate && endDate) {
				values.unshift({
					amount: -beforeStartNAVAdj, // 开始的数据需要取反
					date: this.pbf.time(startDate),
				});
			}
			// console.log("beforeStartValues:", beforeStartValues);
			// console.log("values:", values);
			if (values.length > 0) {
				let guess = 0.1;
				const sumAmount = values
					.map((item) => item.amount)
					.reduce((prev, curr) => prev + curr, 0);
				if (sumAmount < 0) {
					guess = -0.1;
				}
				//SMP2-2249 fixed the big irr issue
				if (sumAmount === 0) {
					args.value = 0;
				} else {
					const valueItems = values.slice(0, values.length - 1);
					const valueList = valueItems.map((item) => item.amount);
					const dateList = valueItems.map((item) => item.date);
					const lastItem = values[values.length - 1];
					const navAdjust = lastItem.amount;
					const latestDate = lastItem.date;
					let irr =
						this.dashboardPorletsService.ExcelFormulas._CalculateXirr(
							valueList,
							dateList,
							navAdjust,
							latestDate
						);
					args.value = irr === null ? "" : irr;
				}
			} else {
				args.value = "";
			}
			// console.log("args.value:", args.value);
			if (
				this.pivotObj.engineModule &&
				this.pivotObj.engineModule.formatFields[args.fieldName]
			) {
				delete this.pivotObj.engineModule.formatFields[args.fieldName];
				this.pivotObj.engineModule.formatFields[args.fieldName] = {
					name: args.fieldName,
					format:
						field.length > 0
							? field[0].format &&
							  field[0].format.length &&
							  field[0].format[0].formatChecked
								? this.dashboardPorletsService.pivotTableformatPercent(
										field[0].format[0].selectedFormat
								  )
								: this.dashboardPorletsService.formatPercent(
										field[0].dp
								  )
							: "P2",
				};
			}
		}

		//  SMP2-16520 TWR 月/季/年 && SMP2-16683 VAR
		if (
			[
				"CalculateTWRMTD",
				"CalculateTWRQTD",
				"CalculateTWRYTD",
				"CalculateVARMTD_99",
				"CalculateVARQTD_99",
				"CalculateVARYTD_99",
				"CalculateVARMTD_95",
				"CalculateVARQTD_95",
				"CalculateVARYTD_95",
			].includes(args.aggregateType)
		) {
			// console.log("==========================");
			// console.log("args:", args);
			let valueField = "IRRAdjValue";
			let dateField = "IRRDate";
			let timeRange;
			switch (args.aggregateType) {
				case "CalculateTWRMTD":
				case "CalculateVARMTD_99":
				case "CalculateVARMTD_95":
					timeRange = "month";
					break;
				case "CalculateTWRQTD":
				case "CalculateVARQTD_99":
				case "CalculateVARQTD_95":
					timeRange = "quarter";
					break;
				case "CalculateTWRYTD":
				case "CalculateVARYTD_99":
				case "CalculateVARYTD_95":
					timeRange = "year";
					break;
				default:
					break;
			}
			let values = []; // 这个阶段的累计集合
			let field = this.configFields.filter(
				(el) =>
					el.colName ===
					this.dashboardPorletsService.getAggregateType(
						args.aggregateType
					)
			);
			for (let i = 0; i < args.cellSets.length; i++) {
				const data = {
					[valueField]: args.cellSets[i][valueField],
					date:
						this.pbf.time(args.cellSets[i][dateField]) ===
						"Invalid date"
							? asOfDate
							: this.pbf.time(args.cellSets[i][dateField]),
				};
				values.push(data);
			}

			// 如果asOfDate不是 本月/季度/年 的最后一天，都是截至 上个月/季度/年 的最后一天的数据去计算
			let _asOfDate = moment(asOfDate);
			// console.log("_asOfDate:", _asOfDate);
			let isEndOfPeriod = (unit) => {
				return (
					_asOfDate.format("YYYY-MM-DD") ===
					_asOfDate.endOf(unit).format("YYYY-MM-DD")
				);
			};
			let endDate = isEndOfPeriod(timeRange)
				? moment(asOfDate).format("YYYY-MM-DD")
				: moment(asOfDate)
						.subtract(1, timeRange)
						.endOf(timeRange)
						.format("YYYY-MM-DD");

			// console.log("endDate:", endDate);
			values = values.filter((item) =>
				moment(item.date).isSameOrBefore(endDate)
			);
			values = sortBy(values, "date");
			// console.log("values:", values);

			if (values.length > 0) {
				let result = this.getTimeRanges(
					values,
					endDate,
					timeRange,
					"date"
				); // 各个阶段的数据
				let resultTotal = {}; // 各个阶段总和
				for (const prop in result) {
					resultTotal[prop] = result[prop].reduce((acc, cur) => {
						return acc + (cur[valueField] || 0);
					}, 0);
				}
				// console.log("result:", result);
				// console.log("resultTotal:", resultTotal);

				const cumulativeSum = {}; // 各个阶段累计和
				let sum = 0;
				for (const key of Object.keys(resultTotal)) {
					sum += resultTotal[key];
					cumulativeSum[`${key}`] = sum;
				}
				// console.log("cumulativeSum:", cumulativeSum);

				const keys = Object.keys(cumulativeSum);
				let twrList = [];
				// 遍历每两个阶段 计算TWR
				for (let i = 0; i < keys.length - 1; i++) {
					const key1 = keys[i];
					const key2 = keys[i + 1];

					// 计算两个阶段之间的递增量, 出数不能为0
					if (cumulativeSum[key1] != 0) {
						const increment =
							cumulativeSum[key2] - cumulativeSum[key1];
						let twr = increment / cumulativeSum[key1];
						twrList.push({
							date: key2,
							twr: twr,
						});
					}
				}
				// 计算Average TWR
				// console.log("twrList:", twrList);
				let averageTWR = this.calculateGrowthRate(
					twrList.map((x) => x.twr)
				);
				// console.log("计算Average TWR:", averageTWR);
				if (
					[
						"CalculateTWRMTD",
						"CalculateTWRQTD",
						"CalculateTWRYTD",
					].includes(args.aggregateType)
				) {
					// SMP2-16520 TWR 月/季/年
					args.value =
						isNaN(averageTWR) || averageTWR == null
							? ""
							: Number(averageTWR);
				} else {
					if (isNaN(averageTWR) || averageTWR == null) {
						args.value = "";
					} else {
						// SMP2-16683 VAR 区分99%和95%
						let ZScore = [
							"CalculateVARMTD_99",
							"CalculateVARQTD_99",
							"CalculateVARYTD_99",
						].includes(args.aggregateType)
							? 2.33
							: 1.65;
						if (twrList.length < 2) {
							args.value = "";
						} else {
							let SD = this.calculateStandardDeviation(
								twrList.map((x) => x.twr)
							);
							// console.log("calculateStandardDeviation:", SD);
							let VAR = averageTWR - SD * ZScore;
							args.value = Number(VAR);
						}
					}
				}
				// console.log("args.value:", args.value);
			}

			if (
				this.pivotObj.engineModule &&
				this.pivotObj.engineModule.formatFields[args.fieldName]
			) {
				delete this.pivotObj.engineModule.formatFields[args.fieldName];
				this.pivotObj.engineModule.formatFields[args.fieldName] = {
					name: args.fieldName,
					format:
						field.length > 0
							? field[0].format &&
							  field[0].format.length &&
							  field[0].format[0].formatChecked
								? this.dashboardPorletsService.pivotTableformatPercent(
										field[0].format[0].selectedFormat
								  )
								: this.dashboardPorletsService.formatPercent(
										field[0].dp
								  )
							: "P2",
				};
			}
		}

		//SMP2-2701
		if (args.aggregateType === "CalculateIRRActualAudited") {
			let NAVAdj = 0;
			let values = [];
			let field = this.configFields.filter(
				(el) =>
					el.colName ===
					this.dashboardPorletsService.getAggregateType(
						args.aggregateType
					)
			);
			//SMP2-2713 only judge for this dataMart(GrossNet)
			if (
				this.portlet.figureCode === "GrossNet" ||
				this.portlet.figureCode ===
					"CombinedInvestmentFundNCompanyCashflow"
			) {
				for (let i = 0; i < args.cellSets.length; i++) {
					const data = {
						amount: args.cellSets[i]["IRRAmount"],
						date:
							this.pbf.time(args.cellSets[i]["IRRDate"]) ===
							"Invalid date"
								? asOfDate
								: this.pbf.time(args.cellSets[i]["IRRDate"]),
					};
					NAVAdj += args.cellSets[i]["ActualAuditedNAV"];
					if (data.amount != 0) {
						values.push(data);
					}
				}
			}
			//filter the data by the DataType(Actual Reported Audited)
			else {
				let argsdata = args.cellSets.filter(
					(el) =>
						el.DataType === "ACTUAL_AUDITED" ||
						el.DataType === "REPORTED"
				);
				for (let i = 0; i < argsdata.length; i++) {
					const data = {
						amount: argsdata[i]["IRRAmount"],
						date:
							this.pbf.time(argsdata[i]["IRRDate"]) ===
							"Invalid date"
								? asOfDate
								: this.pbf.time(argsdata[i]["IRRDate"]),
					};
					NAVAdj += argsdata[i]["IRRAdjValue"];
					if (data.amount != 0) {
						values.push(data);
					}
				}
			}
			if (NAVAdj > 0.0001 || NAVAdj < -0.0001) {
				values.push({
					amount: NAVAdj,
					date: asOfDate,
				});
			}
			values = sortBy(values, "date");
			if (values.length > 0) {
				let guess = 0.1;
				const sumAmount = values
					.map((item) => item.amount)
					.reduce((prev, curr) => prev + curr, 0);
				if (sumAmount < 0) {
					guess = -0.1;
				}
				//SMP2-2249 fixed the big irr issue
				if (sumAmount === 0) {
					args.value = 0;
				} else {
					const valueItems = values.slice(0, values.length - 1);
					const valueList = valueItems.map((item) => item.amount);
					const dateList = valueItems.map((item) => item.date);
					const lastItem = values[values.length - 1];
					const navAdjust = lastItem.amount;
					const latestDate = lastItem.date;
					let irr =
						this.dashboardPorletsService.ExcelFormulas._CalculateXirr(
							valueList,
							dateList,
							navAdjust,
							latestDate
						);
					args.value = irr === null ? 0 : irr;
				}
			} else {
				args.value = 0;
			}
			if (
				this.pivotObj.engineModule &&
				this.pivotObj.engineModule.formatFields[args.fieldName]
			) {
				delete this.pivotObj.engineModule.formatFields[args.fieldName];
				this.pivotObj.engineModule.formatFields[args.fieldName] = {
					name: args.fieldName,
					format:
						field.length > 0
							? field[0].format &&
							  field[0].format.length &&
							  field[0].format[0].formatChecked
								? this.dashboardPorletsService.pivotTableformatPercent(
										field[0].format[0].selectedFormat
								  )
								: this.dashboardPorletsService.formatPercent(
										field[0].dp
								  )
							: "P2",
				};
			}
		}
		//SMP2-3411
		if (args.aggregateType === "CalculateIRRReported") {
			let NAVAdj = 0;
			let values = [];
			let field = this.configFields.filter(
				(el) =>
					el.colName ===
					this.dashboardPorletsService.getAggregateType(
						args.aggregateType
					)
			);
			if (
				this.portlet.figureCode === "GrossNet" ||
				this.portlet.figureCode ===
					"CombinedInvestmentFundNCompanyCashflow"
			) {
				for (let i = 0; i < args.cellSets.length; i++) {
					const data = {
						amount: args.cellSets[i]["IRRAmount"],
						date:
							this.pbf.time(args.cellSets[i]["IRRDate"]) ===
							"Invalid date"
								? asOfDate
								: this.pbf.time(args.cellSets[i]["IRRDate"]),
					};
					NAVAdj += args.cellSets[i]["ReportedNAV"];
					if (data.amount != 0) {
						values.push(data);
					}
				}
			} else {
				for (let i = 0; i < args.cellSets.length; i++) {
					const data = {
						amount: args.cellSets[i]["IRRAmount"],
						date:
							this.pbf.time(args.cellSets[i]["IRRDate"]) ===
							"Invalid date"
								? asOfDate
								: this.pbf.time(args.cellSets[i]["IRRDate"]),
					};
					NAVAdj += args.cellSets[i]["IRRAdjValue"];
					if (data.amount != 0) {
						values.push(data);
					}
				}
			}
			if (NAVAdj > 0.0001 || NAVAdj < -0.0001) {
				values.push({
					amount: NAVAdj,
					date: asOfDate,
				});
			}
			values = sortBy(values, "date");
			if (values.length > 0) {
				let guess = 0.1;
				const sumAmount = values
					.map((item) => item.amount)
					.reduce((prev, curr) => prev + curr, 0);
				if (sumAmount < 0) {
					guess = -0.1;
				}
				//SMP2-2249 fixed the big irr issue
				if (sumAmount === 0) {
					args.value = 0;
				} else {
					const valueItems = values.slice(0, values.length - 1);
					const valueList = valueItems.map((item) => item.amount);
					const dateList = valueItems.map((item) => item.date);
					const lastItem = values[values.length - 1];
					const navAdjust = lastItem.amount;
					const latestDate = lastItem.date;
					let irr =
						this.dashboardPorletsService.ExcelFormulas._CalculateXirr(
							valueList,
							dateList,
							navAdjust,
							latestDate
						);

					args.value = irr === null ? 0 : irr;
				}
			} else {
				args.value = 0;
			}
			if (
				this.pivotObj.engineModule &&
				this.pivotObj.engineModule.formatFields[args.fieldName]
			) {
				delete this.pivotObj.engineModule.formatFields[args.fieldName];
				this.pivotObj.engineModule.formatFields[args.fieldName] = {
					name: args.fieldName,
					format:
						field.length > 0
							? field[0].format &&
							  field[0].format.length &&
							  field[0].format[0].formatChecked
								? this.dashboardPorletsService.pivotTableformatPercent(
										field[0].format[0].selectedFormat
								  )
								: this.dashboardPorletsService.formatPercent(
										field[0].dp
								  )
							: "P2",
				};
			}
		}
		if (
			args.aggregateType === "CalculateMultiple" ||
			args.aggregateType === "CalculatePIC" ||
			args.aggregateType === "CalculateDPI" ||
			args.aggregateType === "CalculateTVPI" ||
			args.aggregateType === "CalculateRVPI" ||
			args.aggregateType === "CalculateMActualAudited" ||
			args.aggregateType === "CalculateMReported"
		) {
			let totalNumerator = 0;
			let totalDenominator = 0;
			let numeratorName;
			let denominatorName;
			let field = this.configFields.filter(
				(el) =>
					el.colName ===
					this.dashboardPorletsService.getAggregateType(
						args.aggregateType
					)
			);
			if (field.length > 0) {
				const formulaArray = field[0].formula.split("/");
				numeratorName = formulaArray[0];
				denominatorName = formulaArray[1];
			}
			for (let j = 0; j < args.cellSets.length; j++) {
				totalNumerator += args.cellSets[j][numeratorName];
				totalDenominator += args.cellSets[j][denominatorName];
			}
			if (totalDenominator !== 0) {
				args.value = totalNumerator / totalDenominator;
				if (
					this.pivotObj.engineModule &&
					this.pivotObj.engineModule.formatFields[args.fieldName]
				) {
					delete this.pivotObj.engineModule.formatFields[
						args.fieldName
					];
					this.pivotObj.engineModule.formatFields[args.fieldName] = {
						name: args.fieldName,
						format:
							field.length > 0
								? field[0].format &&
								  field[0].format.length &&
								  field[0].format[0].formatChecked
									? this.dashboardPorletsService.pivotTableformatMultiple(
											field[0].format[0].selectedFormat
									  )
									: this.dashboardPorletsService.formatMultiple(
											field[0].dp
									  )
								: "###0.00'x'",
					};
				}
			} else {
				args.value = "";
			}
		}

		if (args.aggregateType === "First" || args.aggregateType === "Last") {
			args.value = this.calculatedFistLast(
				args,
				args.aggregateType,
				args.fieldName
			);
		}

		if (
			args.aggregateType === "Count" ||
			args.aggregateType === "DistinctCount"
		) {
			if (args.value) {
				args.value = args.value.toFixed(2);
			}
		}

		if (
			!args.value &&
			args.value !== 0 &&
			args.value !== false &&
			args.value !== "false"
		) {
			args.skipFormatting = true;
			args.value = "";
		}
		// 新建pivot table, 还没有设置row, 选了column之后grandtotal会有值
		if (
			args.rowCellType === "grandTotal" &&
			!this.pivotObj.dataSourceSettings.rows.length
		) {
			args.value = "";
		}
		//SMP2-2889
		if (args.rowCellType === "subTotal") {
			const valueField_data = this.config.yaxis.series.filter(
				(el) => el.colName === args.fieldName
			);
			if (valueField_data.length > 0) {
				if (valueField_data[0].showSubTotals === false) {
					args.value = "";
					args.skipFormatting = true;
				}
			}
		}
		if (args.rowCellType === "grandTotal") {
			const valueField_data = this.config.yaxis.series.filter(
				(el) => el.colName === args.fieldName
			);
			if (valueField_data.length > 0) {
				if (valueField_data[0].showGrandTotals === false) {
					args.value = "";
					args.skipFormatting = true;
				}
			}
		}
		// SMP2-3416 start
		if (
			this.zeroFormatData.hgList.includes(args.fieldName) &&
			args.value === 0
		) {
			args.value = "-";
			args.skipFormatting = true;
		}
		if (
			this.zeroFormatData.emptyList.includes(args.fieldName) &&
			args.value === 0
		) {
			args.value = "";
			args.skipFormatting = true;
		}
		if (
			this.millionFields.includes(args.fieldName) &&
			!isNaN(Number(args.value)) &&
			args.value !== 0 &&
			args.value !== "" &&
			args.value !== null
		) {
			if (
				args.columnCellType == "grandTotal" &&
				args.rowCellType == "grandTotal"
			) {
				if (!this.totalFormatted[args.fieldName]) {
					this.totalFormatted[args.fieldName] = true;
					args.value = args.value / 1000000;
				}
			} else {
				args.value = args.value / 1000000;
			}
		}

		// SMP2-2486 & percentNum的format问题
		if (
			this.percentNumFields.length &&
			this.percentNumFields.includes(args.fieldName) &&
			!isNaN(Number(args.value)) &&
			args.value !== 0 &&
			args.value !== "" &&
			args.value !== null
		) {
			if (
				args.columnCellType == "grandTotal" &&
				args.rowCellType == "grandTotal"
			) {
				if (!this.totalFormatted[args.fieldName]) {
					this.totalFormatted[args.fieldName] = true;
					args.value = args.value / 100;
				}
			} else {
				args.value = args.value / 100;
			}
		}
		if (
			args.aggregateType == "CalculatedField" &&
			!isNaN(Number(args.value)) &&
			!this.pivotObj.engineModule.formatFields[args.fieldName].format
		) {
			args.value = Number(args.value).toFixed(2);
		}
		// SMP2-3416 end
		this.ref.markForCheck();
		this.ref.detectChanges();
	}

	private calculatedFistLast(args, aggregateType, fieldName) {
		if (!args.row.actualText) args.row.actualText = args.row.formattedText;
		if (!args.column.actualText)
			args.column.actualText = args.column.formattedText;
		let field = this.configFields.filter(
			(el) => el.colName === fieldName
		)[0];
		if (args.rowCellType === "value" && !args.row.hasChild) {
			if (args.cellSets[0]) {
				if (aggregateType === "First") {
					for (
						let firstIndex = 0;
						firstIndex < args.cellSets.length;
						firstIndex++
					) {
						if (
							this.pivotObj.dataSourceSettings.columns.length ==
								1 &&
							args.columnCellType == "grandTotal"
						) {
							if (
								field.dataType == "string" ||
								field.dataType == "nvarchar" ||
								field.dataType == "date" ||
								field.dataType == "datetime"
							) {
								args.value = "";
							} else {
								if (
									this.allDataValue &&
									this.allDataValue.length
								) {
									let rowObjs =
										this.allDataValue[args.row.rowIndex];
									if (rowObjs) {
										let rowObjsArr = JSON.parse(
											JSON.stringify(rowObjs)
										);
										let obj = rowObjsArr.filter(
											(el) =>
												el.actualText == fieldName &&
												el.isGrandSum
										)[0];
										if (obj) args.value = obj.value;
									}
								} else {
									args.value = isNaN(
										Number(
											this.grandTotals[
												"row" +
													args.row.actualText +
													fieldName
											]
										)
									)
										? null
										: Number(
												this.grandTotals[
													"row" +
														args.row.actualText +
														fieldName
												]
										  );
								}
							}
						} else {
							args.value = args.cellSets[firstIndex][fieldName];
						}
						if (
							field.dataType == "number" ||
							field.dataType == "multiple" ||
							field.dataType == "percent" ||
							field.dataType == "percentNum"
						) {
							if (args.value != null) break;
						} else if (
							field.dataType == "date" ||
							field.dataType == "datetime"
						) {
							if (this.pbf.time(args.value) > "1900-01-01") break;
						} else if (args.value) break;
					}
				}
				if (aggregateType === "Last") {
					for (
						let lastIndex = args.cellSets.length - 1;
						lastIndex >= 0;
						lastIndex--
					) {
						if (
							this.pivotObj.dataSourceSettings.columns.length ==
								1 &&
							args.columnCellType == "grandTotal"
						) {
							if (
								field.dataType == "string" ||
								field.dataType == "nvarchar" ||
								field.dataType == "date" ||
								field.dataType == "datetime"
							) {
								args.value = "";
							} else {
								if (
									this.allDataValue &&
									this.allDataValue.length
								) {
									let rowObjs =
										this.allDataValue[args.row.rowIndex];
									if (rowObjs) {
										let rowObjsArr = JSON.parse(
											JSON.stringify(rowObjs)
										);
										let obj = rowObjsArr.filter(
											(el) =>
												el.actualText == fieldName &&
												el.isGrandSum
										)[0];
										if (obj) args.value = obj.value;
									}
								} else {
									args.value = isNaN(
										Number(
											this.grandTotals[
												"row" +
													args.row.actualText +
													fieldName
											]
										)
									)
										? null
										: Number(
												this.grandTotals[
													"row" +
														args.row.actualText +
														fieldName
												]
										  );
								}
							}
						} else {
							args.value = args.cellSets[lastIndex][fieldName];
						}

						if (
							field.dataType == "number" ||
							field.dataType == "multiple" ||
							field.dataType == "percent" ||
							field.dataType == "percentNum"
						) {
							if (args.value != null) break;
						} else if (
							field.dataType == "date" ||
							field.dataType == "datetime"
						) {
							if (this.pbf.time(args.value) > "1900-01-01") break;
						} else if (args.value) break;
					}
				}

				if (
					field.dataType == "number" ||
					field.dataType == "multiple" ||
					field.dataType == "percent" ||
					field.dataType == "percentNum"
				) {
					if (this.pivotObj.dataSourceSettings.rows.length) {
						if (!this.pivotObj.dataSourceSettings.columns.length) {
							if (
								!Number(this.grandTotals[fieldName]) ||
								isNaN(Number(this.grandTotals[fieldName]))
							) {
								this.grandTotals[fieldName] = 0;
							}
							if (args.aggregateType !== "CalculatedField") {
								this.grandTotals[fieldName] += Number(
									args.value
								);
							}
						} else if (
							this.pivotObj.dataSourceSettings.columns.length == 1
						) {
							// "row" + args.row.actualText + fieldName 表示(cell: args.rowCellType === "value" && args.columnCellType === "grandTotal")
							if (
								!Number(
									this.grandTotals[
										"row" + args.row.actualText + fieldName
									]
								) ||
								isNaN(
									Number(
										this.grandTotals[
											"row" +
												args.row.actualText +
												fieldName
										]
									)
								)
							) {
								this.grandTotals[
									"row" + args.row.actualText + fieldName
								] = 0;
							}
							this.grandTotals[
								"row" + args.row.actualText + fieldName
							] += Number(args.value);

							// "col" + args.column.actualText + fieldName 表示(cell: args.rowCellType === "grandTotal" && args.columnCellType === "value")
							if (
								!Number(
									this.grandTotals[
										"col" +
											args.column.actualText +
											fieldName
									]
								) ||
								isNaN(
									Number(
										this.grandTotals[
											"col" +
												args.column.actualText +
												fieldName
										]
									)
								)
							) {
								this.grandTotals[
									"col" + args.column.actualText + fieldName
								] = 0;
							}
							this.grandTotals[
								"col" + args.column.actualText + fieldName
							] += Number(args.value);
						}
					}
				}
			}
		} else if (args.rowCellType === "subTotal" || args.row.hasChild) {
			const dataType = field.dataType;
			if (
				dataType === "string" ||
				dataType === "nvarchar" ||
				dataType == "date" ||
				dataType == "datetime"
			) {
				args.value = "";
			} else {
				let value = 0;
				let childHeaders = [];
				if (aggregateType === "First") {
					let groupNameArrays = [];
					let rows = this.pivotObj.dataSourceSettings.rows;
					for (
						let index = args.row.level;
						index < rows.length;
						index++
					) {
						groupNameArrays.push(rows[index].name);
					}
					for (let i = 0; i < args.cellSets.length; i++) {
						let values = [];
						let header = groupNameArrays
							.map((name) => {
								values.push(args.cellSets[i][name]);
								return args.cellSets[i][name];
							})
							.join("-");
						if (!(childHeaders as any).includes(header)) {
							let filterObj: any = {};
							groupNameArrays.map(
								(name, x) => (filterObj[name] = values[x])
							);
							let _CellSets = _filter(args.cellSets, filterObj);
							childHeaders.push(header);
							value += Number(_CellSets[0][fieldName]) || 0;
						}
					}
				}
				if (aggregateType === "Last") {
					let groupNameArrays = [];
					let rows = this.pivotObj.dataSourceSettings.rows;
					for (
						let index = args.row.level;
						index < rows.length;
						index++
					) {
						groupNameArrays.push(rows[index].name);
					}
					for (let i = args.cellSets.length - 1; i >= 0; i--) {
						let values = [];
						let header = groupNameArrays
							.map((name) => {
								values.push(args.cellSets[i][name]);
								return args.cellSets[i][name];
							})
							.join("-");
						if (!(childHeaders as any).includes(header)) {
							let filterObj: any = {};
							groupNameArrays.map(
								(name, x) => (filterObj[name] = values[x])
							);
							let _CellSets = _filter(args.cellSets, filterObj);
							childHeaders.push(header);
							value +=
								Number(
									_CellSets[_CellSets.length - 1][fieldName]
								) || 0;
						}
					}
				}

				if (args.column.actualText !== "Grand Total")
					this.columnTexts.push(args.column.actualText);

				if (!this.pivotObj.dataSourceSettings.columns.length) {
					if (
						!Number(this.subTotals[fieldName]) ||
						isNaN(Number(this.subTotals[fieldName]))
					) {
						this.subTotals[fieldName] = 0;
					}
					this.subTotals[fieldName] += Number(value);
				} else if (
					this.pivotObj.dataSourceSettings.columns.length == 1
				) {
					if (
						!Number(
							this.subTotals[
								args.row.actualText +
									args.column.actualText +
									fieldName
							]
						) ||
						isNaN(
							Number(
								this.subTotals[
									args.row.actualText +
										args.column.actualText +
										fieldName
								]
							)
						)
					) {
						this.subTotals[
							args.row.actualText +
								args.column.actualText +
								fieldName
						] = 0;
					}
					this.subTotals[
						args.row.actualText + args.column.actualText + fieldName
					] += Number(value);
				}
				// ---> allDataValue中这个单元格的值不正确
				if (
					args.columnCellType === "grandTotal" &&
					this.pivotObj.dataSourceSettings.columns.length == 1
				) {
					if (this.allDataValue && this.allDataValue.length) {
						args.value =
							this.subTotals[
								args.row.actualText + "Grand Total" + fieldName
							];
					} else {
						this.columnTexts = uniqBy(this.columnTexts, (el) => el);
						let val = 0;
						for (let i = 0; i < this.columnTexts.length; i++) {
							const element = this.columnTexts[i];
							val +=
								this.subTotals[
									args.row.actualText + element + fieldName
								];
						}
						args.value = val;
					}
				} else {
					args.value = value;
				}
			}
		} else if (args.rowCellType === "grandTotal") {
			const dataType = field.dataType;
			if (
				dataType == "string" ||
				dataType == "nvarchar" ||
				dataType == "date" ||
				dataType == "datetime"
			) {
				args.value = "";
			} else {
				if (!this.pivotObj.dataSourceSettings.columns.length) {
					if (this.allDataValue && this.allDataValue.length) {
						let rowObjs =
							this.allDataValue[this.allDataValue.length - 1];
						if (rowObjs) {
							let rowObjsArr = JSON.parse(
								JSON.stringify(rowObjs)
							);
							let objArr = rowObjsArr.filter(
								(el) =>
									el.actualText == fieldName && el.isGrandSum
							);
							if (objArr && objArr.length) {
								args.value = objArr[objArr.length - 1].value;
							} else if (
								Object.keys(this.grandTotals).includes(
									fieldName
								)
							) {
								args.value = this.grandTotals[fieldName];
							}
						}
					} else {
						args.value = this.grandTotals[fieldName];
					}
				} else {
					if (args.columnCellType === "grandTotal") {
						if (this.allDataValue && this.allDataValue.length) {
							let rowObjs =
								this.allDataValue[this.allDataValue.length - 1];
							if (rowObjs) {
								let rowObjsArr = JSON.parse(
									JSON.stringify(rowObjs)
								);
								let objArr = rowObjsArr.filter(
									(el) =>
										el.actualText == fieldName &&
										el.isGrandSum
								);
								if (objArr && objArr.length) {
									args.value =
										objArr[objArr.length - 1].value;
								} else if (
									Object.keys(this.grandTotals).includes(
										"col" +
											args.column.actualText +
											fieldName
									)
								) {
									args.value =
										this.grandTotals[
											"col" +
												args.column.actualText +
												fieldName
										];
								}
							}
						} else {
							args.value =
								this.grandTotals[
									"col" + args.column.actualText + fieldName
								];
						}
					} else {
						if (this.allDataValue && this.allDataValue.length) {
							let rowObjs =
								this.allDataValue[this.allDataValue.length - 1];
							let rowObjsArr = JSON.parse(
								JSON.stringify(rowObjs)
							);
							let objArr = rowObjsArr.filter(
								(el) =>
									el.actualText == fieldName &&
									el.isGrandSum &&
									el.columnHeaders == args.column.actualText
							);
							if (objArr && objArr.length) {
								args.value = objArr[objArr.length - 1].value;
							} else if (
								Object.keys(this.grandTotals).includes(
									"col" + args.column.actualText + fieldName
								)
							) {
								args.value =
									this.grandTotals[
										"col" +
											args.column.actualText +
											fieldName
									];
							}
						} else {
							args.value =
								this.grandTotals[
									"col" + args.column.actualText + fieldName
								];
						}
					}
				}
			}
		}
		this.formatVal(args, fieldName);
		return args.value;
	}

	private formatVal(args, fieldName) {
		this.configFields.forEach((field) => {
			if (field.colName == fieldName) {
				switch (field.dataType) {
					case "date":
					case "datetime":
						if (args.value) args.value = new Date(args.value);
						break;
					default:
						break;
				}
			}
		});
	}

	private getexcludeFields(fields, data) {
		let namearray = [];
		let array = [];
		for (let prop in data) {
			array.push(prop);
		}
		for (let item of fields) {
			namearray.push(item.colName);
		}
		this.excludeFields = differenceWith(array, namearray);
		if (
			this.excludeFields.length &&
			this.config.groupSettings &&
			this.config.groupSettings.length
		) {
			for (let i = 0; i < this.excludeFields.length; i++) {
				const el = this.excludeFields[i];
				if (startsWith(el, this.config.groupSettings[0].name + "_")) {
					this.excludeFields.splice(i, 1);
					i--;
				}
			}
		}
	}

	private getInfo() {
		this.datePipeFormat = localStorage.getItem("datePipe");
		this.translation = getTranslation()
	}

	public onFieldDrop(args: FieldDropEventArgs) {
		this.dataSourceSettings.values = [...args.dataSourceSettings.values];
		//change the calcualteField method use the corresponding calculate
		const calcualteField = this.configFields.filter(
			(el) => el.colName === args.fieldName && el.isCalculatedField
		);
		if (calcualteField.length > 0) {
			args.dropField.type =
				this.dashboardPorletsService.getCalculateMethod(
					calcualteField[0].colName
				) as any;
			args.dropField.caption = args.dropField.caption
				.replace("Calculate", "")
				.trim();
		}
		for (
			let i = 0;
			i < args.dataSourceSettings.filterSettings.length;
			i++
		) {
			if (
				args.dataSourceSettings.filterSettings[i].name ===
					args.fieldName &&
				args.dropAxis === ""
			) {
				args.dataSourceSettings.filterSettings.splice(i, 1);
				this.filterSettings = args.dataSourceSettings.filterSettings;
				break;
			}
		}
	}

	// Calculated field事件：创建
	public calculatedFieldCreate(args: CalculatedFieldCreateEventArgs) {
		if (
			args.calculatedField.name !== "" &&
			args.calculatedField.name.trim() !== ""
		) {
			let index =
				this.fieldlistObj.dataSourceSettings.calculatedFieldSettings.findIndex(
					(el) => el.name === args.calculatedField.name
				);
			if (index !== -1) {
				if (args.calculatedField.formatString === "") {
					this.fieldlistObj.dataSourceSettings.calculatedFieldSettings[
						index
					].formatString = "N2";
				} else {
					this.fieldlistObj.dataSourceSettings.calculatedFieldSettings[
						index
					].formatString = args.calculatedField.formatString;
				}
			} else {
				if (args.calculatedField.formatString === "") {
					args.calculatedField.formatString = "N2";
				}
			}
			// 移除重复
			let fIndex = this.customCalculatedFields.findIndex(
				(f) => f.name === args.calculatedField.name
			);
			if (fIndex > -1) {
				this.customCalculatedFields.splice(fIndex, 1);
			}
			// 匹配运算符 First || Last
			let formulaStr = args.calculatedField.formula;
			let reg1 = /"First\((.+?)\)"/g;
			let reg2 = /"Last\((.+?)\)"/g;
			if (reg1.test(formulaStr) || reg2.test(formulaStr)) {
				// 判断是否存在First || Last 表达式
				let matchFirstFields = Array.from(
					formulaStr["matchAll"](/"First\((.+?)\)"/g),
					(m) => {
						return {
							matchStr: m[0],
							matchWord: m[1],
							replaceValue: "",
							matchMethod: "First",
						};
					}
				);
				let matchLastFields = Array.from(
					formulaStr["matchAll"](/"Last\((.+?)\)"/g),
					(m) => {
						return {
							matchStr: m[0],
							matchWord: m[1],
							replaceValue: "",
							matchMethod: "Last",
						};
					}
				);
				let matchMaxFields = Array.from(
					formulaStr["matchAll"](/"Max\((.+?)\)"/g),
					(m) => {
						return {
							matchStr: m[0],
							matchWord: m[1],
							replaceValue: "",
							matchMethod: "Max",
						};
					}
				);
				let matchMinFields = Array.from(
					formulaStr["matchAll"](/"Min\((.+?)\)"/g),
					(m) => {
						return {
							matchStr: m[0],
							matchWord: m[1],
							replaceValue: "",
							matchMethod: "Min",
						};
					}
				);
				let matchSumFields = Array.from(
					formulaStr["matchAll"](/"Sum\((.+?)\)"/g),
					(m) => {
						return {
							matchStr: m[0],
							matchWord: m[1],
							replaceValue: "",
							matchMethod: "Sum",
						};
					}
				);
				let matchAvgFields = Array.from(
					formulaStr["matchAll"](/"Avg\((.+?)\)"/g),
					(m) => {
						return {
							matchStr: m[0],
							matchWord: m[1],
							replaceValue: "",
							matchMethod: "Avg",
						};
					}
				);
				if (
					matchFirstFields.every((x) =>
						this.allowedCalculatedFields.includes(x.matchWord)
					) &&
					matchLastFields.every((x) =>
						this.allowedCalculatedFields.includes(x.matchWord)
					)
				) {
					// 判断First和Last表达式内的字段是否合法
					this.customCalculatedFields.push({
						name: args.calculatedField.name,
						formula: args.calculatedField.formula,
						matchFields: [
							// @ts-ignore
							...matchFirstFields,
							...matchLastFields,
							...matchMaxFields,
							...matchMinFields,
							...matchSumFields,
							...matchAvgFields,
						],
						grandTotal: 0,
					});
					let fieldName = (
						formulaStr.split("First(")[1] ||
						formulaStr.split("Last(")[1]
					).split(")")[0];
					args.calculatedField.formula =
						"'\"" + "Sum(" + fieldName + ')"=' + formulaStr + "'";
				}
			}
		}
	}

	// Calculated field事件：完成
	public actionComplete(args) {
		if (
			args.actionName === "Field aggregated" ||
			args.actionName === "Field list closed"
		) {
			this.dataSourceSettings.values = [
				...args.dataSourceSettings.values,
			];
			this.setValueItemData();
		}
		if (args.actionName == "Field removed") {
			if (
				args.fieldInfo &&
				args.fieldInfo.fieldItem &&
				args.fieldInfo.fieldItem.type == "CalculatedField"
			) {
				let field = args.fieldInfo.fieldName;
				// Remove the deleted calculated field from an stored array.
				this.customCalculatedFields =
					this.customCalculatedFields.filter(function (obj) {
						return obj.name !== field;
					});
			}
		}
	}

	// Calculated field事件：开始
	public actionBegin(args) {
		if (args.actionName === "Edit calculated field") {
			for (let i = 0; i < this.customCalculatedFields.length; i++) {
				if (
					this.customCalculatedFields[i].name &&
					this.pivotObj.engineModule.fieldList[
						this.customCalculatedFields[i].name
					]
				) {
					this.pivotObj.engineModule.fieldList[
						this.customCalculatedFields[i].name
					].formula = this.customCalculatedFields[i].formula;
				}
			}
		}
	}

	private resizeStop(args) {
		if (this.config.columnsWidth) {
			const header_field = this.config.columnsWidth.filter(
				(el) => el.headerText === args.column.headerText
			);
			if (header_field.length > 0) {
				header_field[0].width = parseInt(args.column.width);
			} else {
				this.config.columnsWidth.push({
					headerText: args.column.headerText,
					width: parseInt(args.column.width),
				});
			}
		} else {
			this.config.columnsWidth = [];
			this.config.columnsWidth.push({
				headerText: args.column.headerText,
				width: parseInt(args.column.width),
			});
		}
		const portlet = this.portlet;
		portlet.config = JSON.stringify(this.config);
		const index = this.portlets.findIndex((x) => x.newId === portlet.newId);
		if (index > -1) this.portlets[index] = portlet;
	}

	private setColumnsRender(args) {
		if (args.stackedColumns) {
			args.stackedColumns.forEach((col) => {
				if (
					col.format &&
					(col.format.indexOf("N") !== -1 ||
						col.format === "percent" ||
						col.format.indexOf("P") !== -1)
				) {
					col.textAlign = "Right";
				}
			});
		}

		if (this.config.columnsWidth) {
			for (let i = 0; i < (args as any).columns.length; i++) {
				if (
					args.columns[i].headerText === "" ||
					!args.columns[i].headerText
				) {
					const column_row = this.config.columnsWidth.filter(
						(el) => el.headerText === args.columns[i].headerText
					);
					if (column_row.length > 0) {
						args.columns[i].width = column_row[0].width;
					}
				} else {
					const headerText = args.columns[i].headerText
						.replace(/\s+/g, "")
						.split(".");
					if (headerText && headerText.length > 0) {
						const column = this.config.columnsWidth.filter(
							(el) =>
								el.headerText
									.replace(/\s+/g, "")
									.toLowerCase() ===
								headerText[headerText.length - 1].toLowerCase()
						);
						if (column.length > 0) {
							(args as any).columns[i].width = column[0].width;
						}
					}
				}
				// date format about quarterly
				let pivotValues: any = this.pivotObj.pivotValues;
				if (this.formatDates && this.formatDates.length) {
					let dateFields = this.formatDates.map((el) => {
						return el.name;
					});
					for (let k = 1; k < pivotValues.length; k++) {
						for (
							let j = 0;
							pivotValues[k] != null && j < pivotValues[k].length;
							j++
						) {
							if (
								pivotValues[k][j] != null &&
								(j == 0
									? dateFields.includes(
											pivotValues[k][j].valueSort.axis
									  )
									: dateFields.includes(
											pivotValues[k][j].actualText
									  ))
							) {
								//Customize the Row headers/Column headers based on your needs
								let headers;
								if (j === 0) {
									headers = pivotValues[k][j].actualText;
								} else {
									// headers = pivotValues[k][j].formattedText;
									headers = pivotValues[k][j].value;
								}
								if (headers) {
									let date = new Date(headers);

									let quarter =
										Math.floor(date.getMonth() / 3) + 1;

									let format;

									this.formatDates.map((el) => {
										if (j == 0) {
											if (
												el.name ==
												pivotValues[k][j].valueSort.axis
											)
												format = el.format;
										} else {
											if (
												el.name ==
												pivotValues[k][j].actualText
											)
												format = el.format;
										}
									});
									pivotValues[k][j].formattedText =
										this.getQuarterValue(
											format,
											date,
											quarter
										);
								}
							}
						}
					}
				}
			}
			// if(this.pivotObj) this.pivotObj.refreshData();
		}
	}

	public onLoad(): void {
		// SMP2-15651 开启虚拟滚动并sort列后，来回滚动会导致数据空白
		// 官方链接 https://ej2.syncfusion.com/angular/documentation/pivotview/virtual-scrolling#virtual-scrolling-for-static-field-list
		// Demo链接 https://stackblitz.com/edit/github-7ggk2u-4rkzb3?file=src%2Fapp.component.ts
		(this.fieldlistObj as PivotFieldListComponent).pivotGridModule = this
			.pivotObj as PivotViewComponent;
	}

	ondataBound(){
		if (Browser.isDevice) {
            this.pivotObj.element.style.width = '100%';
            this.pivotObj.allowCalculatedField = true;
            this.pivotObj.showFieldList = true;
        }
	}

	private enginePopulated(args) {
		let clonedValues: IPivotValues;
		let currentPivotValues: any = this.getClonedPivotValues(
			this.pivotObj.engineModule.pivotValues
		);
		let pageSettings: IPageSettings =
			this.pivotObj.engineModule.pageSettings;

		if (this.pivotObj.engineModule.generateGridData) {
			// 没法复现 https://raiselp.atlassian.net/browse/SMP2-1724 处理的这个问题情况, 直接注释掉
			// 下面这段代码会影响 https://raiselp.atlassian.net/browse/SMP2-12139
			// this.pivotObj.engineModule.generateGridData(
			// 	this.pivotObj.dataSourceSettings,
			// 	true
			// );
			clonedValues = this.getClonedPivotValues(
				this.pivotObj.engineModule.pivotValues
			);

			this.pivotObj.engineModule.pivotValues = currentPivotValues;

			this.pivotObj.engineModule.pageSettings = pageSettings;

			// Here "clonedValues" contains the whole pivot values.
			this.allDataValue = clonedValues;
		}
	}

	private getClonedPivotValues(pivotValues: IPivotValues): IPivotValues {
		let clonedSets: IPivotValues = [];
		if (pivotValues && pivotValues.length) {
			for (let i: number = 0; i < pivotValues.length; i++) {
				if (pivotValues[i]) {
					clonedSets[i] = [];
					for (let j: number = 0; j < pivotValues[i].length; j++) {
						if (pivotValues[i][j]) {
							/* eslint-disable */
							clonedSets[i][j] = this.getClonedPivotValueObj(
								pivotValues[i][j] as { [key: string]: Object }
							);
							/* eslint-enable */
						}
					}
				}
			}
		}
		return clonedSets;
	}

	private getClonedPivotValueObj(data: { [key: string]: Object }): {
		[key: string]: Object;
	} {
		let keyPos: number = 0;
		let framedSet: any = {};
		if (!(data === null || data === undefined)) {
			let fields: string[] = Object.keys(data);
			while (keyPos < fields.length) {
				framedSet[fields[keyPos]] = data[fields[keyPos]];
				keyPos++;
			}
		} else {
			framedSet = data;
		}
		return framedSet;
	}

	//#region Filtering the TreeNodes
	private searchNodes(args) {
		let _text = args.maskedValue;
		let predicats = [],
			_array = [],
			_filter = [];
		if (_text == "") {
			this.changeDataSource(
				((this as any).fieldlistObj.treeViewModule as any).getTreeData()
			);
		} else {
			let predicate = new Predicate("caption", "contains", _text, true);
			let filteredList = new DataManager(
				((this as any).fieldlistObj.treeViewModule as any).getTreeData()
			).executeLocal(new Query().where(predicate));
			for (let j = 0; j < filteredList.length; j++) {
				_filter.push(filteredList[j]["id"]);
				let filters = this.getFilterItems(
					filteredList[j],
					(
						(this as any).fieldlistObj.treeViewModule as any
					).getTreeData()
				);
				for (let i = 0; i < filters.length; i++) {
					if (
						_array.indexOf(filters[i]) == -1 &&
						filters[i] != null
					) {
						_array.push(filters[i]);
						predicats.push(
							new Predicate("id", "equal", filters[i], false)
						);
					}
				}
			}
			if (predicats.length == 0) {
				this.changeDataSource([]);
			} else {
				let query = new Query().where(Predicate.or(predicats));
				let newList = new DataManager(
					(
						(this as any).fieldlistObj.treeViewModule as any
					).getTreeData()
				).executeLocal(query);
				this.changeDataSource(newList);
			}
		}
	}

	//Find the Parent Nodes for corresponding childs
	public getFilterItems(fList, list) {
		let nodes = [];
		nodes.push(fList["id"]);
		let query2 = new Query().where("id", "equal", fList["pid"], false);
		let fList1 = new DataManager(list).executeLocal(query2);
		if (fList1.length != 0) {
			let pNode = this.getFilterItems(fList1[0], list);
			for (let i = 0; i < pNode.length; i++) {
				if (nodes.indexOf(pNode[i]) == -1 && pNode[i] != null)
					nodes.push(pNode[i]);
			}
			return nodes;
		}
		return nodes;
	}

	public created(args: any) {
		if (this.fieldlistObj && !this.fieldlistObj.engineModule.fields) {
			this.fieldlistObj.engineModule.fields = [];
		}
		let search = document.createElement("input");
		search.id = "pivotSearchBox" + this.fieldlistObj.element.id;
		let el = document.querySelector(
			"#" + this.fieldlistObj.element.id + "_Container .e-field-table"
		);
		if (el) el.prepend(search);
		this.pivotSearchBox = new MaskedTextBox({
			placeholder: this.translation.SEARCH || ".SEARCH",
			cssClass: "pivot-search",
			change: this.searchNodes.bind(this),
		});
		this.pivotSearchBox.appendTo(
			"#pivotSearchBox" + this.fieldlistObj.element.id
		);

		// NEW Dashboard 点击"apply"时，请求新数据
		let applyBtn = document.getElementById(
			this.fieldlistObj.element.id + "_DeferUpdateButton1"
		);

		applyBtn &&
			applyBtn.addEventListener("click", () => {
				this.pageLoading = true;
				this.dashboardPorletsService.getDataByPortletsNew(
					[this.portlet],
					() => {
						this.pageLoading = false;
						this.Pivot_Data =
							this.dashboardPorletsService.getResultByDataTable(
								this.portlet,
								false,
								false,
								this.dashboard.id
							);
						this.pivotObj.dataSourceSettings.dataSource =
							this.Pivot_Data;

						if (this.Pivot_Data) {
							let groups = this.config.xaxis.groups;
							let rows = [];
							if (groups) {
								for (let gitem of groups) {
									const field = this.configFields.filter(
										(el) => el.colName === gitem.name
									);
									if (field.length > 0) {
										gitem.showSubTotals =
											field[0].showSubTotals;
										gitem.caption =
											field[0].langValue ||
											this.translation[
												field[0].langCode
											] ||
											field[0].langCode ||
											gitem.caption;
									}
									rows.push(gitem);
								}
							}
							this.Pivot_Data.map((data) => {
								rows.forEach((row) => {
									if (data[row.name] === "") {
										data[row.name] = "null";
									}
								});
							});
						}
						if (this.pivotObj) this.pivotObj.refreshData();
						this.ref.markForCheck();
						this.ref.detectChanges();
					},
					null,
					false,
					this.dashboard,
					false
				);
			});
			
		// 点击"cancel"时，恢复原始数据
		let cancelBtn = document.getElementById(
			this.fieldlistObj.element.id + "_DeferUpdateButton2"
		);

		cancelBtn &&
			cancelBtn.addEventListener("click", () => {
				this.pivotObj.dataSourceSettings.dataSource =
					[...this.Pivot_Data];
				if (this.pivotObj) this.pivotObj.refreshData();
				this.ref.markForCheck();
				this.ref.detectChanges();
			});		
	}

	public fieldListRefreshed(args) {
		if (this.pivotSearchBox) {
			this.pivotSearchBox.value = "";
			this.changeDataSource(
				(this.fieldlistObj.treeViewModule as any).getTreeData()
			);
		}
	}

	private changeDataSource(data) {
		let fieldTable = (this as any).fieldlistObj.treeViewModule.fieldTable;
		if (fieldTable) {
			fieldTable.fields = {
				dataSource: data,
				id: "id",
				text: "caption",
				isChecked: "isSelected",
				parentID: "pid",
				iconCss: "spriteCssClass",
			};
		}
	}

	//SMP2-2957 fix the date issue on the raw data
	public drillThrough(args: DrillThroughEventArgs) {
		for (let i = 0; i < args.gridColumns.length; i++) {
			const data = this.configFields.filter(
				(el) => el.colName === args.gridColumns[i].field
			);
			if (data && data.length > 0) {
				if (
					data[0].dataType === "date" ||
					data[0].dataType === "datetime"
				) {
					args.gridColumns[i].type = "date";
				}
			}
		}
	}
	//#endregion

	private setFontSettingConditional(obj, data, code) {
		if (code === -1) {
			obj.style.color = data.negaFontColor;
			obj.style.fontFamily = data.negaFontFamilyValue;
			obj.style.fontSize = data.negaFontSizeValue;
			obj.style.backgroundColor = data.negaBackgroundColor;
		} else {
			obj.style.color = data.fontColor;
			obj.style.fontFamily = data.fontFamilyValue;
			obj.style.fontSize = data.fontSizeValue;
			obj.style.backgroundColor = data.backgroundColor;
		}
	}

	private setCompareConditional(
		negaConditionalFormatObj,
		conditionalFormatObj,
		data
	) {
		if (Math.sign(data.compareValue1) == 0) {
			switch (data.compareSelect) {
				case "LessThan": // 小于
				case "LessThanOrEqualTo": // 小于等于
					negaConditionalFormatObj.value1 = 0;
					negaConditionalFormatObj.conditions = "LessThan";
					this.setFontSettingConditional(
						negaConditionalFormatObj,
						data,
						-1
					);
					break;
				case "GreaterThan": // 大于
				case "GreaterThanOrEqualTo": // 大于等于
					conditionalFormatObj.value1 = 0;
					conditionalFormatObj.conditions = "GreaterThan";
					this.setFontSettingConditional(
						conditionalFormatObj,
						data,
						1
					);
					break;
				case "NotEquals": // 不等于
					negaConditionalFormatObj.value1 = 0;
					negaConditionalFormatObj.conditions = "LessThan";
					this.setFontSettingConditional(
						negaConditionalFormatObj,
						data,
						-1
					);
					conditionalFormatObj.value1 = 0;
					conditionalFormatObj.conditions = "GreaterThan";
					this.setFontSettingConditional(
						conditionalFormatObj,
						data,
						1
					);
					break;
				case "Between": // value1<= val <=value2
					if (Math.sign(data.compareValue2) === 1) {
						conditionalFormatObj.value1 = 0;
						conditionalFormatObj.value2 = Number(
							data.compareValue2
						);
						conditionalFormatObj.conditions = "Between";
						this.setFontSettingConditional(
							conditionalFormatObj,
							data,
							1
						);
					}
					break;
				case "NotBetween": // val >= value2, val <= value1
					if (Math.sign(data.compareValue2) === 1) {
						conditionalFormatObj.value1 = Number(
							data.compareValue2
						);
						conditionalFormatObj.conditions = "GreaterThan";
						this.setFontSettingConditional(
							conditionalFormatObj,
							data,
							1
						);
						negaConditionalFormatObj.value1 = 0;
						negaConditionalFormatObj.conditions = "LessThan";
						this.setFontSettingConditional(
							negaConditionalFormatObj,
							data,
							-1
						);
					}
					break;
				default:
					break;
			}
		} else if (Math.sign(data.compareValue1) === 1) {
			switch (data.compareSelect) {
				case "LessThan": // 小于
				case "LessThanOrEqualTo": // 小于等于
					conditionalFormatObj.value1 = 0;
					conditionalFormatObj.value2 = Number(data.compareValue1);
					conditionalFormatObj.conditions = "Between";
					this.setFontSettingConditional(
						conditionalFormatObj,
						data,
						1
					);
					negaConditionalFormatObj.value1 = 0;
					negaConditionalFormatObj.conditions = "LessThan";
					this.setFontSettingConditional(
						negaConditionalFormatObj,
						data,
						-1
					);
					break;
				case "GreaterThan": // 大于
				case "GreaterThanOrEqualTo": // 大于等于
					conditionalFormatObj.value1 = Number(data.compareValue1);
					conditionalFormatObj.conditions = "GreaterThan";
					this.setFontSettingConditional(
						conditionalFormatObj,
						data,
						1
					);
					break;
				case "Equals": // 等于
					conditionalFormatObj.value1 = Number(data.compareValue1);
					conditionalFormatObj.conditions = "Equals";
					this.setFontSettingConditional(
						conditionalFormatObj,
						data,
						1
					);
					break;
				case "NotEquals": // 不等于
					conditionalFormatObj.value1 = 0;
					conditionalFormatObj.value2 = Number(data.compareValue1);
					conditionalFormatObj.conditions = "Between";
					// push进数组
					conditionalFormatObj.value1 = Number(data.compareValue1);
					conditionalFormatObj.conditions = "GreaterThan";
					// push进数组

					negaConditionalFormatObj.value1 = 0;
					negaConditionalFormatObj.conditions = "LessThanOrEqualTo";
					this.setFontSettingConditional(
						negaConditionalFormatObj,
						data,
						-1
					);
					this.setFontSettingConditional(
						conditionalFormatObj,
						data,
						1
					);
					break;
				case "Between": // value1<= val <=value2
					if (Math.sign(data.compareValue2) === 1) {
						conditionalFormatObj.value1 = Number(
							data.compareValue1
						);
						conditionalFormatObj.value2 = Number(
							data.compareValue2
						);
						conditionalFormatObj.conditions = "Between";
						this.setFontSettingConditional(
							conditionalFormatObj,
							data,
							1
						);
					}
					break;
				case "NotBetween": // val >= value2, val <= value1
					if (Math.sign(data.compareValue2) === 1) {
						conditionalFormatObj.value1 = 0;
						conditionalFormatObj.value2 = Number(
							data.compareValue1
						);
						conditionalFormatObj.conditions = "Between";
						// push进数组
						conditionalFormatObj.value1 = Number(
							data.compareValue2
						);
						conditionalFormatObj.conditions = "GreaterThan";
						// push进数组
						this.setFontSettingConditional(
							conditionalFormatObj,
							data,
							1
						);
					}
					break;
				default:
					break;
			}
		} else if (Math.sign(data.compareValue1) === -1) {
			switch (data.compareSelect) {
				case "LessThan": // 小于
				case "LessThanOrEqualTo": // 小于等于
					negaConditionalFormatObj.value1 = data.compareValue1;
					negaConditionalFormatObj.conditions = data.compareSelect;
					this.setFontSettingConditional(
						negaConditionalFormatObj,
						data,
						-1
					);
					break;
				case "GreaterThan": // 大于
				case "GreaterThanOrEqualTo": // 大于等于
					conditionalFormatObj.value1 = 0;
					conditionalFormatObj.conditions = "GreaterThanOrEqualTo";
					negaConditionalFormatObj.value1 = 0;
					negaConditionalFormatObj.value2 = data.compareValue1;
					negaConditionalFormatObj.conditions = "Between";
					this.setFontSettingConditional(
						conditionalFormatObj,
						data,
						1
					);
					this.setFontSettingConditional(
						negaConditionalFormatObj,
						data,
						-1
					);
					break;
				case "Equals": // 等于
					negaConditionalFormatObj.value1 = data.compareValue1;
					negaConditionalFormatObj.conditions = "Equals";
					this.setFontSettingConditional(
						negaConditionalFormatObj,
						data,
						-1
					);
				case "NotEquals": // 不等于
					negaConditionalFormatObj.value1 = data.compareValue1;
					negaConditionalFormatObj.conditions = "NotEquals";
					this.setFontSettingConditional(
						negaConditionalFormatObj,
						data,
						-1
					);
					conditionalFormatObj.value1 = 0;
					conditionalFormatObj.conditions = "GreaterThan";
					this.setFontSettingConditional(
						conditionalFormatObj,
						data,
						1
					);
					break;
				case "Between": // value1<= val <=value2
					if (Math.sign(data.compareValue2)) {
						negaConditionalFormatObj.value1 = 0;
						negaConditionalFormatObj.value2 = data.compareValue1;
						negaConditionalFormatObj.conditions = "Between";
						this.setFontSettingConditional(
							negaConditionalFormatObj,
							data,
							-1
						);
						conditionalFormatObj.value1 = 0;
						conditionalFormatObj.value2 = data.compareValue2;
						conditionalFormatObj.conditions = "Between";
						this.setFontSettingConditional(
							conditionalFormatObj,
							data,
							1
						);
					} else {
						negaConditionalFormatObj.value1 = data.compareValue1;
						negaConditionalFormatObj.value2 = data.compareValue2;
						negaConditionalFormatObj.conditions = "Between";
						this.setFontSettingConditional(
							negaConditionalFormatObj,
							data,
							-1
						);
					}
					break;
				case "NotBetween": // val >= value2, val <= value1
					if (Math.sign(data.compareValue2)) {
						negaConditionalFormatObj.value1 = data.compareValue1;
						negaConditionalFormatObj.conditions = "LessThan";
						this.setFontSettingConditional(
							negaConditionalFormatObj,
							data,
							-1
						);

						conditionalFormatObj.value1 = data.compareValue2;
						conditionalFormatObj.conditions = "GreaterThan";
						this.setFontSettingConditional(
							conditionalFormatObj,
							data,
							1
						);
					} else {
						negaConditionalFormatObj.value1 = data.compareValue1;
						negaConditionalFormatObj.value2 = data.compareValue2;
						negaConditionalFormatObj.conditions = "NotBetween";
						this.setFontSettingConditional(
							negaConditionalFormatObj,
							data,
							-1
						);

						conditionalFormatObj.value1 = 0;
						conditionalFormatObj.conditions = "GreaterThan";
						this.setFontSettingConditional(
							conditionalFormatObj,
							data,
							1
						);
					}
					break;
				default:
					break;
			}
		}
	}

	private getQuarterValue(format, date, quarter) {
		let year: any;
		switch (format) {
			case "Q1 2021":
				year = date.getFullYear();
				return "Q" + quarter + " " + year;
			case "Q1 21":
				year = (date as any).getYear() - 100;
				return "Q" + quarter + " " + year;
			case "2021 Q1":
				year = date.getFullYear();
				return year + " " + "Q" + quarter;
			case "21 Q1":
				year = (date as any).getYear() - 100;
				return year + " " + "Q" + quarter;
		}
	}

	customiseCell(args: QueryCellInfoEventArgs) {
		if (args.column.type === "date" || args.column.type === "dateTime") {
			const { field } = args.column;
			if (!args.data[field]) {
				args.column.type = "string";
				args.column.format = "";
			}
		}
	}

	/**
	 * @param timeArray 数组对象 [{"date":"2021-01-01"},{"date":"2021-02-01"}]
	 * @param endDate 截至时间
	 * @param interval 时间间隔 year / quarter / month
	 * @param timeKey 时间字段名 date
	 * @returns 划分后的时间分组对象
	 */
	getTimeRanges(timeArray, endDate, interval, timeKey) {
		// 将时间字符串转换为 moment 对象
		const dates = timeArray.map((item) => moment(item[timeKey || "date"]));

		// 分隔符
		const delimiter = "-";

		// 找到最小时间和最大时间
		const minDate = moment.min(dates);
		const maxDate = moment(endDate);

		// 初始化结果对象
		const result = {};

		// 根据入参进行划分
		if (interval === "year") {
			const startYear = minDate.year();
			const endYear = maxDate.year();

			for (let year = startYear; year <= endYear; year++) {
				result[year] = [];
			}

			dates.forEach((date, index) => {
				const year = date.year();
				result[year].push(timeArray[index]);
			});
		} else if (interval === "quarter") {
			// 存储季度字符串
			const quarters = [];

			// 逐一遍历每个季度
			for (
				let currentDate = minDate.clone();
				currentDate.isSameOrBefore(maxDate);
				currentDate.add(3, "months")
			) {
				const year = currentDate.year();
				const quarter = Math.ceil((currentDate.month() + 1) / 3); // 计算季度
				quarters.push(`${year}${delimiter}Q${quarter}`); // 格式化并添加到数组
			}

			// 输出所有季度
			quarters.forEach((quarter, index) => {
				result[quarter] = [];
			});

			dates.forEach((date, index) => {
				const year = date.year();
				const quarter = date.quarter(); // 获取季度
				if (quarter === 1)
					result[year + delimiter + "Q1"].push(timeArray[index]);
				else if (quarter === 2)
					result[year + delimiter + "Q2"].push(timeArray[index]);
				else if (quarter === 3)
					result[year + delimiter + "Q3"].push(timeArray[index]);
				else if (quarter === 4)
					result[year + delimiter + "Q4"].push(timeArray[index]);
			});
		} else if (interval === "month") {
			// 存储月份字符串
			const months = [];

			// 逐一遍历每个月
			for (
				let currentDate = minDate.clone();
				currentDate.isSameOrBefore(maxDate);
				currentDate.add(1, "months")
			) {
				months.push(currentDate.format(`YYYY${delimiter}MM`)); // 格式化并添加到数组
			}

			// 输出所有月份
			months.forEach((month, index) => {
				result[month] = [];
			});

			dates.forEach((date, index) => {
				const year = date.year();
				const month = (date.month() + 1).toString().padStart(2, "0"); // 0-11
				result[year + delimiter + month].push(timeArray[index]);
			});
		}

		return result;
	}

	/**
	 * 计算几何算数平方更
	 * @param values 数组 [0, 0, 0.2575]
	 * @returns
	 */
	calculateGrowthRate(values) {
		const product = values.reduce((acc, val) => acc * (1 + val), 1);
		if (product >= 0) {
			return Math.pow(product, 1 / values.length) - 1;
		} else if (product < 0) {
			if (values.length % 2 == 0) {
				return null;
			} else {
				return this.nthroot(product, values.length) - 1;
			}
		}
	}
	nthroot(x, n) {
		let ng = n % 2;
		if (ng == 1 || x < 0) x = -x;
		var r = Math.pow(x, 1 / n);
		n = Math.pow(r, n);

		if (Math.abs(x - n) < 1 && x > 0 === n > 0) return ng ? -r : r;
	}

	/**
	 * 标准偏差
	 * @param values 数组 [0, 0, -0.4775]
	 * @returns 0.2756847535380463
	 */
	calculateStandardDeviation(values) {
		const n = values.length;

		// 检查数据点数量
		if (n < 2) {
			throw new Error("至少需要两个数据点来计算样本标准偏差");
		}

		// 计算均值
		const mean = values.reduce((acc, val) => acc + val, 0) / n;

		// 计算方差
		const variance =
			values.reduce((acc, val) => acc + Math.pow(val - mean, 2), 0) /
			(n - 1);

		// 返回标准偏差
		return Math.sqrt(variance);
	}
}
